import React, { Component, lazy } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Prompt } from 'react-router-dom'
import axios from 'axios'
import qs from 'query-string'
import i18n from '../i18n'
import { Trans } from "react-i18next";
import MimeType from 'mime-types'
import { GetBaseUrl, GetOriginalBaseUrl, GetDefaultUrl } from '@/utils/ConfigHelper'
import { mode } from "webconfig"
import { PaletteItemTooltipContent } from '../MakeVideo/Common/PaletteItemTooltipContent'
import WaveSurfer from 'wavesurfer.js'
import LoadImage from 'blueimp-load-image'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import MakingPanel from '../MakeVideo/MakingPanel/MakingPanel'
import ImageCropDialog from '../MakeVideo/Common/v2/ImageCropDialog'
import VideoCropDialog from '../MakeVideo/Common/VideoCrop/VideoCrop'
import GettyCropDialog from '../MakeVideo/Common/VideoCrop/GettyVideoCrop'
import NewGettyCropDialog from '../MakeVideo/Common/VideoCrop/NewGettyVideoCrop'
import EditVideoMusicDialog from '../MakeVideo/Common/EditVideoMusicDialog'
import TwoBtnDialog from '../Common/TwoBtnDialog/TwoBtnDialog'
import { CREDIT_PRODUCT_TYPE, EDITOR_POLICY, GetIsAiUiUpdate, MYSOURCE_SOURCE_TYPE, MYSOURCE_PROVIDER_TYPE } from '@/utils/Global'
import AiTextDialog from '@/Common/AiTextDialog/AiTextDialog'

import TemplateHelper from '@/utils/TemplateHelper'
import Loading from '@/Common/loading/loading'
import { ErrorHandler, GetPublicErrorCode } from "@/utils/Error/Handler"
import DataManager from '@/utils/DataManager'
import { ProviderApis, VideosApis, TemplatesApis } from '@/utils/Videomonster/Apis';
import UnavailableDialog from '@/MakeVideo/PaletteMenu/Palette/RatioPalette/UnavailableDialog/UnavailableDialog'
import "./MakeVideo.scss"
import TokenHelper from '@/utils/DataManager/TokenHelper'

const WorkspacePalette = lazy(() => import('../MakeVideo/PaletteMenu/Palette/WorkspacePalette'))
const FontPalette = lazy(() => import('../MakeVideo/PaletteMenu/Palette/FontPalette'))
const MusicPalette = lazy(() => import('../MakeVideo/PaletteMenu/Palette/MusicPalette'))
const RatioPalette = lazy(() => import('../MakeVideo/PaletteMenu/Palette/RatioPalette/RatioPalette'))
const PaletteMenu = lazy(() => import('../MakeVideo/PaletteMenu/PaletteMenu'))
const Timeline = lazy(() => import('../MakeVideo/Timeline/Timeline'))
const PaletteItem = lazy(() => import('../MakeVideo/PaletteMenu/PaletteItem/PaletteItem'))
const Uploading = lazy(() => import('@/Common/Uploading/Uploading'))
const PreviewImage = lazy(() => import('../MakeVideo/PreviewImage/PreviewImage'))
const UploadCompleted = lazy(() => import('@/Common/UploadCompleted/UploadCompleted'))
const AdjustLengthAlertDialog = lazy(() => import('../MakeVideo/AdjustLengthAlertDialog/AdjustLengthAlertDialog'))
const PaletteFont = lazy(() => import('../MakeVideo/PaletteMenu/PaletteFont/PaletteFont'))
const Maintain = lazy(() => import('../Common/Maintain/Maintain'))
const Tutorial = lazy(() => import('../Common/Tutorial/Tutorial'))
const TutorialEn = lazy(() => import('../Common/Tutorial/TutorialEn/TutorialEn'))
const TopBarV2 = lazy(() => import('@/Common/TopBarV2/index'))

const formWaveSurferOptions = ref => ({
    container: ref,
    waveColor: "#c1c1c1",
    progressColor: "#990000",
    cursorWidth: 0,
    barWidth: 2,
    barRadius: 1,
    barGap: 2,
    responsive: true,
    height: 40,
    width: `100%`,
    partialRender: true,
    hideScrollbar: true,
    interact: false
});

const MAX_COPY_COUNT = 2
const STRETCH_ADJUST_VALUE = 0.2

const STRETCH_INCREASE_ALERT_VALUE = (4 / 3) * 100 // 133.3333
const STRETCH_DECREASE_ALERT_VALUE = 75

const STRETCH_INCREASE_LIMIT_VALUE = 200
const STRETCH_DECREASE_LIMIT_VALUE = 50

const MAX_VIDEO_LENGTH = 60; 



const STANDARD_RATIO = ['16:9', '1:1', '9:16', '4:5']

class MakeVideo extends Component {
    cropper;
    isAiUiUpdate = GetIsAiUiUpdate()
    constructor(props) {
        super(props)
     
        this.state = {
            sceneGroups: [],
            selectedMenu: this.isAiUiUpdate ? "workspace" : "media",
            template: null,
            selectedIndex: 0,
            selectedSceneGroupIndex: 0,
            selectedSceneGroupElementId: 'group-0',
            videoName: "",
            templateName: "",
            material: {
                Footage: [],
                Text: [],
                Music: null
            },
            globalFontList: [],
            myFontList: [],
            fullWidth: true,
            isUploaded: false,              // Upload 팝업 표시여부
            isImageLoading: false,
            isUploadCompleted: false,
            isSaveTemporarilyUploaded: false,
            isSaveTemporarilyUploadCompleted: false,
            title: '',
            visibleTitlePopUp: false,
            isWaitForPreview: false,
            reEditMode: true, //이전에 작성한 뒤로 재작업하는 경우인지?

            imgs: null,
            pathAlert: false,

            isServerCheck: false,
            startDate: undefined,
            endDate: undefined,
            description: undefined,
            // isOpenAds: false,
            number: 10,

            isNoPayment: true,
            tutorialOpen: false, // 템플릿 접속이 최초 일때 사용법 gif로 보여줌.
            saveState: 'none',

            showUploadPercentage: false,    // 임시저장 버튼에 업로드 Percentage 표시 여부
            uploadPercenage: 0,             // 업로드 Percentage,
            // isHideGalleryState: false, // 갤러리로 업로드여부  state
            isCheckGalleryUpload: false,
            isGalleryOpen: false,

            isPreviewImageOpen: false,
            previewSrc: null,

            selectedLayer: -1,
            selectedComposition: null,
            currentTextOption: { fontSize: 0 },
            currentTextLayerAttr: { fillColor: false, strokeColor: false },

            isFontFileUploading: false,
            fontFileUploadProgress: 0,

            lang: 'ko',
            lastPreviewRequestedDate: Date.now() - 60 * 1000,
            region: null,

            isOpenMusicLengthNoticeDialog: false, // 음악 길이 짧다는 팝업
            isOpenReturnToDefaultMusicDialog: false, // 음악 되돌리기 물어보는 팝업
            isReadyWavesurfer: false, // 파형 데이터가 준비 되었는가?
            isOpenMusicLengthSettingDialog: false, // 음악 재설정, 음악 재생시간 초과 팝업
            isOpenMusicSectionSettingDialog: false, // 음악 재생구간 초과 팝업
            isOpenUseCreditDialog: false, // 크레딧 차감 확인 팝업
            isOpenAiTextDialog: false, // 크레딧 차감 확인 팝업
            changeMusicInfo: null,
            isContinueShortMusic: false,

            cropBlobData: null,
            cropUploadType: null,
            cropMetaData: null,

            availableFunc: {},
            isEditableApproved: false,
            isPremium:false,
            calculatedVideoLength: 0,
            isShowAdjustLengthAlert: false,
            
            isShowGallery: true,
            isVchangeUser: false,
            //현재 씬 텍스트 레이어 존재 여부
            isTextLayer: true,
            //무료 유저 프리미엄 기능 사용시 알림 팝업
            isPaymentAlertDialogOpen: false,
            isLoading: false,
            selectedRatio: '9:16',
            groupData: undefined,
            ratioArr: [],
            isUnavailableDialogOpen: false,
			selectedAiTool: CREDIT_PRODUCT_TYPE.REMOVE_BG,
            now: null,
        }
    }

    waveformRef
    wavesurfer

    // isHideGalleryStateDefaultValue

    isSaving = false
    isChangeRatio = false

    /*
    {file,name,type (image,video)}
    */
    palette = [];
    // unsplashProvider = null;
    // pexelsProvider = null
    // pixabayProvider = null
    templateId = '';

    footageCount = 0;

    lastUpdated = null
    autoSaveInterval
    //서버에서 삭제된 파일이 있을경우 deletedCompFile Componstion 이름으로 저장
    deletedCompFile = {};
    cashedMediaInfoMap = {
        /*
         [fileName]: { 
             url: `https://videomonsterpublicdev.blob.core.windows.net/5c8f17db5348a10022ef4742-music/5f7eac8128c5db9980ba957f.m4a`, 
             type: `video` or `audio,
             data: `blobdata...` 
         }
        */
    }

    modifiedMap = {}
    previewImageURL = {}
    
    cutPreviewMap = {}
    originTemplateData
    videoLengthWhenContinue
    videoLengthWhenMusicChanged
    media = []
    fileObj = {}

    setMedia = (media) => this.media = media

    getId() {
        return qs.parse(window.location.search, { ignoreQueryPrefix: true }).id
    }

    getIsVideoMaxLengthExceed = (duration, videoLength = this.state.calculatedVideoLength) => {
        return Number((duration + videoLength).toFixed(2)) > MAX_VIDEO_LENGTH;
    }

    getFontPaletteAvaliableCheck = () => {
        const { isVchangeUser, availableFunc } = this.state
        return (isVchangeUser || availableFunc.FontChange)
    }

    getCurrentSceneTextLayerInfo = (template = this.state.template, index = this.state.selectedIndex) => {
        let selectedLayer = -1
        let isTextLayer = true;
        let compName = null;
        const layer = template.Scenes[index]
        if (layer && layer.Layers) {
            const fontLayerIndex = layer.Layers.findIndex((item) => item.Type === "Text");
            selectedLayer = this.state.selectedMenu === "font" ? fontLayerIndex : -1;
            isTextLayer = fontLayerIndex === -1 ? false : true;

            if (isTextLayer) compName = layer.Layers[fontLayerIndex].Name
        }
        return { selectedLayer, isTextLayer, compName }
    }

    getOriginVideoLength = () => {
        const { originTemplateData } = this
        let originVideoLength = 0

        originTemplateData && originTemplateData.cuts && originTemplateData.cuts.length > 0 && 
        originTemplateData.cuts.forEach(cut => {
            let duration = cut.outPoint - cut.inPoint 
            let beforeCutOverlapDuration = cut.beforeCutOverlapDuration || 0
            let stretch = 1
            originVideoLength += (duration + beforeCutOverlapDuration) * stretch
        })
        return originVideoLength
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.template && nextProps.value !== this.props.value) {
            //언어 변경 시 sceneGroupPopUpMenuProps position이 바뀌어서 메뉴가 위치가 이상해짐 state를 변경해서 강제 reRender
            const elementId = this.state.selectedSceneGroupElementId;
            this.setState({ selectedSceneGroupElementId: null }, () => {
                this.setState({ selectedSceneGroupElementId: elementId });
            });
        }

    }

    async componentDidMount() {
        try {
            const { currentUser, history } = this.props
            const id = this.getId()
            if (!id) return this.props.history.push('/user/_')

            window.onbeforeunload = function () {
                return false
            // eslint-disable-next-line no-extra-bind
            }.bind(this)
            
            // if (!this.autoSaveInterval) {
            //     this.autoSaveInterval = setInterval(function () {
            //         console.log(`[AUTO SAVE CHECK]`, this.lastUpdated, Date.now() - this.lastUpdated, " - ", EDITOR_POLICY.AutoSave.SaveInterval, Date.now() - this.lastUpdated > EDITOR_POLICY.AutoSave.SaveInterval)
            //         if (this.lastUpdated !== null && Date.now() - this.lastUpdated > EDITOR_POLICY.AutoSave.SaveInterval) {
            //             this.sendSaveTemporarilyRequest(true, true).catch()
            //         }
            //     }.bind(this), EDITOR_POLICY.AutoSave.CheckInterval)
            // }

            // const channel = document.querySelector("#ch-plugin-core");
            // if (channel !== null) {
            //     channel.classList.add("hide");
            // }
            
            let isNoPayment = true
            let result = await axios.post(`${GetBaseUrl()}/api/video/paymentcheck`, {
                id
            },
                {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                })
            if (result && result.data) {
                isNoPayment = result.data.isNoPayment
                this.setState({ isNoPayment })
            }

            const provider = DataManager.GetProvider();

            const isShowGallery = !DataManager.IncludesProvider(DataManager.PROVIDER.VCHANGE, DataManager.PROVIDER.CAFE24)
            const isVchangeUser = DataManager.IsProvider(DataManager.PROVIDER.VCHANGE)

            let availableFunc;
            if (provider === DataManager.PROVIDER.CAFE24) {
                availableFunc = {
                    AdjustLength: true,
                    FontChange: true,
                    MusicChange: true,
                    DesignChange: true,
                    PremiumSource: true,
                    Ai: true,
                }
            } else {   
                result = await axios.get(`${GetBaseUrl()}/apis/videos/${id}/avaliable-func`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
				// 수정 예정
                // availableFunc = result.data.data
				availableFunc = {...result.data.data, Ai: true}
            }
            this.setState({ availableFunc, isVchangeUser, isShowGallery })

            let isAvaliableFunctionExists = false
            const funcKeys = Object.keys(availableFunc)
            for (let i = 0; i < funcKeys.length; i++) {
                if (availableFunc[funcKeys[i]]) {
                    isAvaliableFunctionExists = true
                    break
                }
            }

            if (!isNoPayment || isAvaliableFunctionExists) {
                const { isCanPreviewRendering, lastPreviewRequestedDate } = (await axios.get(`${GetBaseUrl()}/api/user/can-preview`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })).data;

                if (!isCanPreviewRendering) {
                    this.setState({ lastPreviewRequestedDate: Date.parse(lastPreviewRequestedDate) })
                }
            }

            const videoResponse = await axios.get(`${GetBaseUrl()}/api/video/preview/${id}`,
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                }
            ) 
            
            let { name, material: oldMaterial, template, lang, previews, isGalleryOpen, url, region } = videoResponse.data
            this.templateId = videoResponse.data.template._id
            this.generateCutPreviewMap(previews)
              
            const { templateData, time, imageCount, isEditableApproved, isPremium } = template
            this.originTemplateData = JSON.parse(JSON.stringify(templateData))

            let reEditMode = (this.props.location.state && this.props.location.state.edit) || (name && !name.includes('New Video'))
            this.setState({ reEditMode, templateOrigin: template, videoUrl: url, videoName: name, templateName: template.name });
        
            if (mode === 'stage') this.setState({ isEditableApproved })
            else this.setState({ isEditableApproved: templateData && templateData.EditableData && templateData.EditableData.isEditable })
   
            if(isPremium && templateData && templateData.EditableData && (templateData.EditableData.type === 1 || templateData.EditableData.type === 2)){
                this.setState({ isPremium:true });
            }

            if (availableFunc.FontChange || isVchangeUser) {
                const fontResponse = await axios.get(`${GetBaseUrl()}/api/font/list`)
                if (fontResponse && fontResponse.data && fontResponse.data.list) {
                    this.setState({ globalFontList: fontResponse.data.list })
                }

                const myFontResponse = await axios.get(`${GetBaseUrl()}/api/font/myfont`,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                    }
                )
                if (myFontResponse && myFontResponse.data && myFontResponse.data.list) {
                    this.setState({ myFontList: myFontResponse.data.list })
                }
            }

            //  var mime = new MimeType();
            if (oldMaterial) {
                oldMaterial = JSON.parse(oldMaterial)
                var preLoadedImage = []
                var preLoadedVideo = []
                // 템플릿에 적용된 커스텀 음악이 나의 음악에 등록되어 잇는지 확인
                if (oldMaterial.Music && oldMaterial.Music.Replace) {
                    const url = oldMaterial.Music.blobURL
                    const name = oldMaterial.Music.Name
                    const provider = oldMaterial.Music.Provider
                    const isCustom = oldMaterial.Music.Custom

                    try {
                        // 음악 파일을 찾은 경우 그대로 고고
                        const response = await axios.get(url, { responseType: 'blob' })
                        const contentType = response.headers['content-type']
                        const firstType = contentType.split("/")[0]

                        // 컨텐츠 형식이 audio가 아니면 Material.Music 초기화
                        if (firstType !== 'audio') { oldMaterial.Music = null }
                        else this.setState({ changeMusicInfo: {url, name, provider, isCustom}})
                    }
                    catch (e) {
                       
                        // 음악 파일을 찾지 못한 경우 Material.Music 초기화
                        oldMaterial.Music = null
                    }
                }

                if (oldMaterial.Footage) {
                    await Promise.all(oldMaterial.Footage.map(async (footage, index) => {
                        const fileName = footage.File.name || footage.Replace;
                        if (!fileName) return
                        if (footage.Meta) {
                            if (footage.Meta.source === 'gettyimages') return


                            if ((!footage.VideoThumbnail || !footage.VideoThumbnail.name) && (!footage.ImageThumbnail || !footage.ImageThumbnail.name)) return
                            const isImageSource = footage.Meta.source === "image";
                            let thumbnailFileName = isImageSource ? footage.ImageThumbnail.name : footage.VideoThumbnail.name
                            try {
                                const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${thumbnailFileName}`, {
                                    headers: {
                                        Authorization: 'Bearer ' + localStorage.getItem('token')
                                    },
                                    responseType: 'blob'
                                })
        
                                const file = new File([response.data], thumbnailFileName, {
                                    type: MimeType.lookup(thumbnailFileName)
                                })
                                if (isImageSource) oldMaterial.Footage[index].ImageThumbnail = file
                                else oldMaterial.Footage[index].VideoThumbnail = file
                            }
                            catch (e) {
                                console.dir(e)
                            }
                        }
                        else {
                            const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${fileName}`, {
                                headers: {
                                    Authorization: 'Bearer ' + localStorage.getItem('token')
                                },
                                responseType: 'blob'
                            })
    
                            const file = new File([response.data], footage.Replace, {
                                type: MimeType.lookup(footage.Replace)
                            })
    
                            oldMaterial.Footage[index].File = file
                        }
                    }))
                    this.generatePreviewImageURLMap(oldMaterial);

                    templateData.Scenes.forEach(scene => {
                        scene.Layers.forEach(layer => {
                            if (layer.Type === `Text`) {
                                let isEmptyComposition = true
                                oldMaterial.Text.forEach(text => {
                                    if (text.Composition == layer.Name) {
                                        isEmptyComposition = false
                                        if (layer.Text) {
                                            text.Placeholder = layer.Text
                                        }
                                    }
                                })

                                if (isEmptyComposition) {
                                    oldMaterial.Text.push({
                                        Composition: layer.Name,
                                        Context: ``,
                                        Placeholder:layer.Text
                                    })
                                }
                            }
                        })
                    })

                    this.setState({ material: oldMaterial, preLoadedImage, preLoadedVideo });
                }
            }
            else {
                const material = {
                    Footage: [],
                    Text: []
                }
                templateData.Scenes.forEach(scene => {
                    scene.Layers.forEach(layer => {
                        if (layer.Type === `Text`) {
                            material.Text.push({
                                Composition: layer.Name,
                                Context: ``,
                                Placeholder:layer.Text
                            })
                        }
                    })
                })
                this.setState({
                    material
                })
            }
            const { isTextLayer } = this.getCurrentSceneTextLayerInfo(templateData);
            
            lang = lang ? lang : 'ko'
            this.setState({ template: templateData, time, lang, previews, isTextLayer, isCheckGalleryUpload: isNoPayment && time >= 10 && imageCount > 2, region }, this.updateSceneData)
            const tutorialRes = await axios.get(`${GetBaseUrl()}/api/user/tutorial-viewed`, { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } })
            if (tutorialRes && tutorialRes.data) {
                const { isViewed } = tutorialRes.data
                this.setState({ tutorialOpen: !isViewed })
            }

            this.getServerCheckData()
            this.getGroupInfo()
        }
        catch (e) {
            const userId = this.props.currentUser ? this.props.currentUser._id : ''
            console.dir(e)
            if (this.props.currentUser && this.props.currentUser._id) ErrorHandler(this, userId, e, { alert: true, server: true })
            this.props.history.push('/user/_')
        }
    }

    getGroupInfo = async () => {
        try {
            if (this.templateId) {
                const token = DataManager.GetToken()
                const { result, data } = await TemplatesApis.GetGroupRatioChange(token, { templateId: this.templateId })
                if (!result || !data) return

                const groupData = data
                let key
                for (let curKey in groupData) {
                    if (groupData[curKey]._id === this.templateId) {
                        key = curKey
                        break
                    }
                }

                const ratioArr = Object.keys(groupData).filter(item => groupData[item].isSupported)
                if (!ratioArr.length) return
                const selectedRatio = STANDARD_RATIO.filter(item => item === key)[0]
                this.setState({ groupData, ratioArr, selectedRatio })
            }
        } catch (e) {
            ErrorHandler(this, null, e, { server: true, alert: true })
        }
    }

    generatePreviewImageURLMap = material => {
        for (const key in this.previewImageURL) {
            URL.revokeObjectURL(this.previewImageURL[key])
        }
        this.previewImageURL = {}
        
        material.Footage.forEach(footage => {
            if (footage.VideoThumbnail instanceof File) {
                this.previewImageURL[footage.Composition] = URL.createObjectURL(footage.VideoThumbnail)
            }
            else if(footage.ImageThumbnail instanceof File){
                this.previewImageURL[footage.Composition] = URL.createObjectURL(footage.ImageThumbnail)
            }
            else if (footage.File instanceof File) {
                this.previewImageURL[footage.Composition] = URL.createObjectURL(footage.File)
            }
        })
    }

    generateCutPreviewMap = previews => {
        const previewMap = {}
        if (Array.isArray(previews)) {
            previews.forEach(preview => {
                const startIndex = preview.toLowerCase().indexOf('/cut')
                const endIndex = preview.toLowerCase().indexOf('.jpg')

                const cutName = preview.toLowerCase().substring(startIndex + 1, endIndex)
                previewMap[cutName] = preview + `?date=${Date.now()}`
            })
        }
        this.cutPreviewMap = previewMap
    }

    updateSceneData = () => {
        const { originTemplateData: { Scenes, EditableData }, cutPreviewMap } = this
        const { template, material, selectedIndex, selectedSceneGroupIndex, lang } = this.state

        const newScenes = JSON.parse(JSON.stringify(Scenes))
        const newPreviews = []
        const sceneGroups = []
        const sceneMap = {}
        const groupMap = {}

        newScenes.forEach(scene => sceneMap[scene.Name] = scene)

        if (EditableData) {
            const { cuts, groups } = EditableData

            const cutMap = {}
            cuts.forEach(cut => cutMap[cut.name] = cut)
            
            newScenes.forEach(scene => {
                const cutData = cutMap[scene.Name]
                if (!cutData) return

                scene.duration = cutData.outPoint - cutData.inPoint 
                scene.beforeCutOverlapDuration = cutData.beforeCutOverlapDuration || 0
                scene.stretch = 1
            })

            if (EditableData.isEditable) {
                groups.forEach(group => {
                    for (const name in group.map) {
                        groupMap[name] = group
                    }
                })
                this.originTemplateData.cuts = cuts
            }
        }


        if (Array.isArray(material.Copy)) {
            const copyMap = {}
            material.Copy.forEach(item => copyMap[item.Composition] = item.Count)

            for (let i = 0; i < newScenes.length; i++) {
                const scene = newScenes[i]
                const copyCount = copyMap[scene.Name]

                if (copyCount) {
                    const group = groupMap[scene.Name]
                    if (group) {
                        const groupLength = Object.keys(group.map).length
                        for (let j = 1; j <= copyCount; j++) {
                            const newGroup = { map: {} }
                            let idx = 0
                            for (const name in group.map) {
                                const newScene = JSON.parse(JSON.stringify(sceneMap[name]))
                                newScene.Name = `${newScene.Name}-${j}`

                                newGroup.map[newScene.Name] = true
                                groupMap[newScene.Name] = newGroup

                                newScene.Layers.forEach(layer => layer.Name = `${layer.Name}-${j}`)
                                newScenes.splice(i + groupLength + idx++, 0, newScene)
                            }
                            i += groupLength
                        }
                    }
                    else {
                        for (let j = 1; j <= copyCount; j++) {
                            const newScene = JSON.parse(JSON.stringify(scene))
                            newScene.Name = `${newScene.Name}-${j}`

                            newScene.Layers.forEach(layer => layer.Name = `${layer.Name}-${j}`)
                            newScenes.splice(i + 1, 0, newScene)
                            i++
                        }
                    }
                }
            }
        }

        const removeMap = {}
        if (Array.isArray(material.Remove)) material.Remove.forEach(item => removeMap[item.Composition] = true)

        let tryCount = 0;
        this.footageCount = 0;
        //템플릿에있는 footage 계산
        if (newScenes && newScenes.length) {
            newScenes.forEach((scene) => {
                scene.Layers.forEach((layer, index) => {
                    if (layer.Type === "Footage") {
                        this.footageCount += 1;
                        if (removeMap[scene.Name]) this.footageCount -= 1;
                    }
                })
            })
        }

        for (let i = 0; i < newScenes.length; i++) {
            const scene = newScenes[i]
            const scenes = []
            let status = 'Activated'

            if (groupMap[scene.Name]) {
                const group = groupMap[scene.Name]
                for (const name in group.map) {
                    scenes.push(name)
                    i++
                }
                i--
            }
            else {
                scenes.push(scene.Name)
            }

            if (removeMap[scene.Name]) status = 'Deleted'
            sceneGroups.push({
                scenes,
                status
            })
            
            if (++tryCount === 1000) {
                const userId = this.props.currentUser ? this.props.currentUser._id : ''
                ErrorHandler(this, userId, new Error('CLIENT_TEMPLATE_ERROR_1'), { alert: true })
                this.props.history.push('/user/_')
                break
            }
        }

        newScenes.forEach(scene => {
            const cutName = scene.Name.toLowerCase().replace('#', '')
            if (cutPreviewMap[cutName]) scene.Preview = cutPreviewMap[cutName]
            else scene.Preview = TemplateHelper.getPreviewImage(scene, lang)

            newPreviews.push(scene.Preview)
        })
        //이미 서버에 계산되어있는 ImageCount는 - 시켜줘야함
        this.footageCount -= template.ImageCount;

        this.setState({
            template: {
                ...template,
                Scenes: newScenes
            },
            previews: newPreviews,
            sceneGroups,
            selectedIndex: Math.min(selectedIndex, Math.max(1, newScenes.length - 1)),
            selectedSceneGroupIndex: Math.min(selectedSceneGroupIndex, sceneGroups.length - 1)
        }, this.updateSceneDuration)
    }

    // Stretch는 수정빈도가 높으므로 분리
    updateSceneDuration = () => {
        const { template: { Scenes, Time, EditableData }, material } = this.state
    
        let calculatedVideoLength = Time
        if (EditableData && EditableData.isEditable) {
            calculatedVideoLength = 0
            
            if (Array.isArray(material.Stretch)) {
                const stretchMap = {}
                material.Stretch.forEach(item => stretchMap[item.Composition] = item.Stretch)
    
                Scenes.forEach(scene => {
                    if (stretchMap[scene.Name]) scene.stretch = stretchMap[scene.Name] / 100
                })
            
            }
    
            const removeMap = {}
            if (Array.isArray(material.Remove)) {
                material.Remove.forEach(item => {
                    removeMap[item.Composition] = true
                    for (let i=0; i<EditableData.groups.length; i++) {
                        const group = EditableData.groups[i]
                        if (group.map[item.Composition]) {
                            for (const name in group.map) {
                                removeMap[name] = true
                            }
                            break
                        }
                    }
                })
            }
    
            Scenes.forEach(scene => {
                if (scene.duration && scene.stretch && !removeMap[scene.Name]) {   
                    calculatedVideoLength += (scene.duration + scene.beforeCutOverlapDuration) * scene.stretch
                }
            })
        }

        this.setState({
            calculatedVideoLength,
            template: {
                ...this.state.template,
                Scenes,
            }
        })
    }

    componentDidUpdate(_, prevState) {
        if (!this.props.currentUser) {
            this.props.history.push('/')
        }
    }

    initMaterialMusic = () => {
        const { material } = this.state
        if (!material) return

        const newMaterial = { ...this.state.material }
        newMaterial.Music = null
        this.setState({ material: newMaterial, changeMusicInfo: null })
    }

    getServerCheckData = () => {
        axios.get(`${GetBaseUrl()}/api/system/servercheck`)
            .then(response => {
                let {
                    isServerCheck,
                    startDate,
                    endDate,
                    description,
                    description_en,
                    description_ve
                } = response.data

                if (isServerCheck === true) {
                    startDate = new Date(startDate)
                    endDate = new Date(endDate)

                    startDate.setHours(startDate.getHours() + 9)
                    endDate.setHours(endDate.getHours() + 9)

                    startDate = `${startDate.toISOString().substr(11, 5)}`
                    endDate = `${endDate.toISOString().substr(11, 5)}`

                    if (this.props.value !== 'ko') {
                        description = description_en
                    }
                }
                this.setState({
                    isServerCheck,
                    startDate,
                    endDate,
                    description
                })
            })
            .catch(e => {
            })
    }

    isSelectedOriginaScene = () => {
        const { sceneGroups, selectedSceneGroupIndex: idx } = this.state
        const selectedSceneGroupIndex = Number(idx)

        if (!sceneGroups || !sceneGroups[selectedSceneGroupIndex]) return false;

        if (sceneGroups[selectedSceneGroupIndex].scenes[0] &&
            !sceneGroups[selectedSceneGroupIndex].scenes[0].includes('-')) return true;
        else return false;
    }
    
    getSelectedSceneGroup = () => {
        const { sceneGroups, selectedSceneGroupIndex: idx, isPremium } = this.state
        const selectedSceneGroupIndex = Number(idx)
       
        if (!sceneGroups || !sceneGroups[selectedSceneGroupIndex]) return

        const obj = { 
            ...sceneGroups[selectedSceneGroupIndex],
            isCopyAvailable: true,
            isDeleteAvailable: false
        }

        const originCutName = sceneGroups[selectedSceneGroupIndex].scenes[0].split('-')[0]
        for (let i = selectedSceneGroupIndex; i < sceneGroups.length; i++) {
            const otherOriginCutName = sceneGroups[i].scenes[0].split('-')[0]

            if (originCutName === otherOriginCutName) {
                const cutNumber = Number(sceneGroups[i].scenes[0].split('-')[1])
                // obj.isDeleteAvailable = true
                // 복사된 컷이 있고, 복사된 컷 선택 시에만 삭제기능 활성화

                if(isPremium) {
                    obj.isDeleteAvailable = true;
                    break;
                }   
               
                if (cutNumber > 0) obj.isDeleteAvailable = true
                if (cutNumber >= 2) {                           // 복사가 2번 이미 되어있는경우 복사기능 비활성화
                    obj.isCopyAvailable = false
                    break
                }
            }
        }
        
        // 복사된 컷이 아닐 경우, 맨 뒤 컷만 삭제 가능
        if (!isPremium && selectedSceneGroupIndex === sceneGroups.length - 1) obj.isDeleteAvailable = true

        // 남은 그룹이 최소 2개 이상이어야 삭제 가능
        if (sceneGroups.filter(group => group.status === 'Activated').length < 2) obj.isDeleteAvailable = false
        
        return obj
    }

    resetCopiedCutsMaterial = (scenes, copiedIdx) => {
        const sceneMap = {}
        scenes.forEach(scene => sceneMap[scene] = true)

        const { material, template: { Scenes } } = this.state
        for (let i = 0; i < Scenes.length; i++) {
            const { Name, Layers } = Scenes[i]
            if (sceneMap[Name]) {
                Layers.forEach(layer => {
                    const originLayerName = layer.Name.split('-')[0]
                    const copiedLayerName = `${originLayerName}-${Number(copiedIdx) + 1}`
                    for (let j=0; j < material.Footage.length; j++) {
                        if (material.Footage[j].Composition === copiedLayerName) {
                            material.Footage.splice(j, 1)
                            break
                        }
                    }

                    for (let j=0; j < material.Text.length; j++) {
                        if (material.Text[j].Composition === copiedLayerName) {
                            material.Text.splice(j, 1)
                            break
                        }
                    }
                    if (originLayerName.toLowerCase().startsWith('#text')) {
                        material.Text.push({ Composition: copiedLayerName, Context: '', Placeholder: layer.Text })
                    }
                })
            }
        }
    }

    handleClickSceneGroupDuplicateMenu = () => {
        const group = this.getSelectedSceneGroup()
        if (!group || !group.scenes) return

        const { material, template: { Scenes }, isPremium, calculatedVideoLength } = this.state;

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        let copyCount = MAX_COPY_COUNT;

        const copiedCutName = group.scenes[0]
        const sceneMap = {}

        group.scenes.forEach(scene => sceneMap[scene] = true)
        
        const sceneData = Scenes.find((scene)=>scene.Name === copiedCutName);

        if(sceneData && this.getIsVideoMaxLengthExceed(sceneData.duration * sceneData.stretch)){
            alert(i18n.t('makevideo.length.exceed.alert'));
            return
        }

        if (this.videoLengthWhenContinue < calculatedVideoLength) this.setState({ isContinueShortMusic: false })

        const Composition = copiedCutName.split('-')[0];
        const copiedIdx = copiedCutName.split('-')[1] || 0;

        if (isPremium) {
            copyCount = 0;
            Scenes.forEach((scene) => {
                if (scene.Name.includes(Composition)) copyCount += 1;
            })

            if (copyCount === 0) copyCount = MAX_COPY_COUNT;
        }

        if (!material.Copy) material.Copy = []
        for (let i = 0; i < material.Copy.length; i++) {
            // 기존에 Copy 데이터가 있을경우 1 증가
            if (material.Copy[i].Composition === Composition) {
                material.Copy[i].Count = material.Copy[i].Count + 1

                // MAX_COPY_COUNT 체크. 통과 시 아래 로직 수행
                if (material.Copy[i].Count <= copyCount) {

                    // 복사된 컷의 Composition 정보를 Map으로 만들기 => #TEXT1: true, #TEXT2: true, #AV1, true
                    const compMap = {}
                    for (let j = 0; j < Scenes.length; j++) {
                        if (sceneMap[Scenes[j].Name]) {
                            Scenes[j].Layers.forEach(layer => compMap[layer.Name.split('-')[0]] = true)
                        }
                    }

                    // 복사된 컷 기준으로, 기존에 있던 뒤에있는 material index를 밀어주기
                    // 
                    // updateSceneData에서 매번 CUT 복사정보를 순차적으로 재구성하기때문에, Count에 변경이 일어날 경우 기존 인덱스 정보를 그대로 이용할 수 없음.
                    // 따라서 Count에 변경이 일어날 때 material의 index를 수정해줘야함.
                    // 
                    // 예) 기본 전제 (#CUT1 => #TEXT1 컴프만 존재함)
                    //   case #CUT1, #CUT1-1이 존재하고 #TEXT1, #TEXT1-1작성됨. 복사를 한 컷(copiedCutName)이 #CUT1일 경우:
                    //   => #TEXT1-1을 #TEXT1-2로 이름을 바꿈.
                    //
                    //   case #CUT1, #CUT1-1이 존재하고 #TEXT1, #TEXT1-1작성됨. 복사를 한 컷(copiedCutName)이 #CUT1-1일 경우:
                    //   => 아무런 작업 수행하지 않음.
                    for (let j = copyCount - 1; j >= Number(copiedIdx) + 1 ; --j) {         
                        material.Footage.forEach(footage => {
                            // 해당 컴프가 복사 대상 #CUT에 해당할 경우
                            const originComp = footage.Composition.split('-')[0] // #AV1-1 => #AV1 이렇게 만들어줘서 compMap에서 확인가능하게끔

                            // 복사 대상 #CUT의 컴프인지 확인 후 리네임
                            const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                            const renameComp = `${originComp}${j + 1 > 0 ? `-${j + 1}` : ''}`
                        
                            if (compMap[originComp] && copiedComp === footage.Composition) {
                                footage.Composition = renameComp    // #AV1-1 => #AV1-2
                            }
                        })
                        material.Text.forEach(text => {
                            // 해당 컴프가 복사 대상 #CUT에 해당할 경우
                            const originComp = text.Composition.split('-')[0] // #TEXT1-1 => #TEXT1 이렇게 만들어줘서 compMap에서 확인가능하게끔

                            const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                            const renameComp = `${originComp}${j + 1 > 0 ? `-${j + 1}` : ''}`

                            // 복사 대상 #CUT의 컴프인지 확인 후 리네임
                            if (compMap[originComp] && copiedComp === text.Composition) {
                                text.Composition = renameComp   // #TEXT1-1 => #TEXT1-2
                            }
                        })
                        if (Array.isArray(material.Stretch)) {
                            material.Stretch.forEach(stretch => {
                                const originComp = stretch.Composition.split('-')[0]
    
                                const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                                const renameComp = `${originComp}${j + 1 > 0 ? `-${j + 1}` : ''}`
    
                                if (copiedComp === stretch.Composition) {
                                    stretch.Composition = renameComp   // #CUT1-1 => #CUT1-2
                                }
                            })
                        }

                        group.scenes.forEach(cutName => {
                            const originCutName = cutName.toLowerCase().split('-')[0].replace('#', '')
    
                            const copiedCutName = `${originCutName}${j > 0 ? `-${j}` : ''}`
                            const renameCutName = `${originCutName}${j + 1 > 0 ? `-${j + 1}` : ''}`
                            
                            this.cutPreviewMap[renameCutName] = this.cutPreviewMap[copiedCutName]
                            this.cutPreviewMap[copiedCutName] = null
                        })
                    }
                  
                    this.resetCopiedCutsMaterial(group.scenes, copiedIdx)
                    this.generatePreviewImageURLMap(material)
                }
                else material.Copy[i].Count = 2
                return this.setState({ material },this.updateSceneData)
            }
        }
        material.Copy.push({
            Composition,
            Count: 1
        })
        
        this.resetCopiedCutsMaterial(group.scenes, copiedIdx)
        this.setState({ material },this.updateSceneData)
    }

    handleClickSceneGroupDeleteMenu = () => {
        const group = this.getSelectedSceneGroup()
        if (!group || !group.scenes) return

        const { material, template: { Scenes }, isPremium, calculatedVideoLength, selectedIndex } = this.state

        if (selectedIndex !== 0 && Scenes.length === selectedIndex + 1) this.selectScene(selectedIndex - 1)

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        let copyCount = MAX_COPY_COUNT;
        
        const removeCutName = group.scenes[0]
        const sceneMap = {}
        group.scenes.forEach(scene => sceneMap[scene] = true)

        const Composition = removeCutName.split('-')[0]
        const copiedIdx = removeCutName.split('-')[1] || 0
        const SceneData = Scenes[selectedIndex];
        if (this.videoLengthWhenContinue >= calculatedVideoLength) this.setState({ isContinueShortMusic: true })

        if (isPremium) {
            copyCount = 0;
            Scenes.forEach((scene) => {
                if (scene.Name.includes(Composition)) copyCount += 1;
            });

            if (copyCount === 0) copyCount = MAX_COPY_COUNT;
        }


        
        if (!material.Copy) material.Copy = []


        for (let i = 0; i < material.Copy.length; i++) {
            // 기존에 Copy 데이터가 있을경우 1 감소
            if (material.Copy[i].Composition === Composition) {
                material.Copy[i].Count--
                // 카운트가 0이 될경우 material에서 제거
                if (material.Copy[i].Count <= 0) material.Copy.splice(i, 1)

                // 제거된 컷의 Composition 정보를 Map으로 만들기 => #TEXT1: true, #TEXT2: true, #AV1, true
                const compMap = {}
                for (let j = 0; j < Scenes.length; j++) {
                    if (sceneMap[Scenes[j].Name]) {
                        Scenes[j].Layers.forEach(layer => compMap[layer.Name.split('-')[0]] = true)
                    }
                }

                // 제거된 컷의 #AV, #TEXT 컴프 제거
                for (let j = 0; j < material.Footage.length; j++) {
                    const footage = material.Footage[j]
                    const originComp = footage.Composition.split('-')[0]    // #AV1-1 => #AV1 이렇게 만들어줘서 compMap에서 확인가능하게끔
                    const copiedComp = `${originComp}${copiedIdx > 0 ? `-${copiedIdx}` : ''}`

                    // 해당 컷의 컴포지션인지 확인 후 제거
                    if (compMap[originComp] && copiedComp === footage.Composition) {
                        material.Footage.splice(j, 1)
                        j--
                    }
                }
                for (let j = 0; j < material.Text.length; j++) {
                    const text = material.Text[j]
                    const originComp = text.Composition.split('-')[0]       // #TEXT1-1 => #TEXT1 이렇게 만들어줘서 compMap에서 확인가능하게끔
                    const copiedComp = `${originComp}${copiedIdx > 0 ? `-${copiedIdx}` : ''}`

                    // 해당 컷의 컴포지션인지 확인 후 제거
                    if (compMap[originComp] && copiedComp === text.Composition) {
                        material.Text.splice(j, 1)
                        j--
                    }
                }
                if (Array.isArray(material.Stretch)) {
                    for (let j = 0; j < material.Stretch.length; j++) {
                        const stretch = material.Stretch[j]
                        const originComp = stretch.Composition.split('-')[0]
                        const copiedComp = `${originComp}${copiedIdx > 0 ? `-${copiedIdx}` : ''}`
    
                        if (copiedComp === stretch.Composition) {
                            material.Stretch.splice(j, 1)
                            j--
                        }
                    }
                }

                // 제거된 컷 기준으로, 기존에 있던 뒤에있는 material index를 밀어주기
                // 
                // updateSceneData에서 매번 CUT 제거정보를 순차적으로 재구성하기때문에, Count에 변경이 일어날 경우 기존 인덱스 정보를 그대로 이용할 수 없음.
                // 따라서 Count에 변경이 일어날 때 material의 index를 수정해줘야함.
                // 
                // 예) 기본 전제 (#CUT1 => #TEXT1 컴프만 존재함)
                //   case #CUT1, #CUT1-1, #CUT1-2이 존재하고 #TEXT1, #TEXT1-1, #TEXT1-2작성됨. 제거를 한 컷(removeCutName)이 #CUT1일 경우:
                //   => #TEXT1-1을 #TEXT1로, #TEXT1-2을 #TEXT1-1로 이름을 바꿈.
                //
                //   case #CUT1, #CUT1-1, #CUT1-2이 존재하고 #TEXT1, #TEXT1-1, #TEXT1-2작성됨. 제거를 한 컷(removeCutName)이 #CUT1-1일 경우:
                //   => #TEXT1-2을 #TEXT1-1로 이름을 바꿈.
                //
                //   case #CUT1, #CUT1-1, #CUT1-2이 존재하고 #TEXT1, #TEXT1-1, #TEXT1-2작성됨. 제거를 한 컷(removeCutName)이 #CUT1-2일 경우:
                //   => 아무런 작업 수행하지 않음.
                for (let j = Number(copiedIdx) + 1; j <= copyCount; j++) {
                  
                    material.Footage.forEach(footage => {
                        // 해당 컴프가 제거 대상 #CUT에 해당할 경우
                        const originComp = footage.Composition.split('-')[0]    // #AV1-1 => #AV1 이렇게 만들어줘서 compMap에서 확인가능하게끔

                        const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                        const renameComp = `${originComp}${j - 1 > 0 ? `-${j - 1}` : ''}`

                        // 제거 대상 #CUT의 컴프인지 확인 후 리네임
                        if (compMap[originComp] && copiedComp === footage.Composition) {
                            footage.Composition = renameComp
                            if(this.modifiedMap[copiedComp]){
                                delete this.modifiedMap[copiedComp]
                                this.modifiedMap[renameComp] = true;
                            }
                        }
                    })
                    material.Text.forEach(text => {
                        // 해당 컴프가 제거 대상 #CUT에 해당할 경우
                        const originComp = text.Composition.split('-')[0]       // #TEXT1-1 => #TEXT1 이렇게 만들어줘서 compMap에서 확인가능하게끔

                        const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                        const renameComp = `${originComp}${j - 1 > 0 ? `-${j - 1}` : ''}`

                        // 제거 대상 #CUT의 컴프인지 확인 후 리네임
                        if (compMap[originComp] && copiedComp === text.Composition) {
                            text.Composition = renameComp
                        }
                    })
                    if (Array.isArray(material.Stretch)) {
                        material.Stretch.forEach(stretch => {
                            const originComp = stretch.Composition.split('-')[0]

                            const copiedComp = `${originComp}${j > 0 ? `-${j}` : ''}`
                            const renameComp = `${originComp}${j - 1 > 0 ? `-${j - 1}` : ''}`

                            if (copiedComp === stretch.Composition) {
                                stretch.Composition = renameComp   // #CUT1-2 => #CUT1-1
                            }
                        })
                    }

                    group.scenes.forEach(cutName => {
                        const originCutName = cutName.toLowerCase().split('-')[0].replace('#', '')

                        const copiedCutName = `${originCutName}${j > 0 ? `-${j}` : ''}`
                        const renameCutName = `${originCutName}${j - 1 > 0 ? `-${j - 1}` : ''}`
                        
                        this.cutPreviewMap[renameCutName] = this.cutPreviewMap[copiedCutName]
                        this.cutPreviewMap[copiedCutName] = null
                    })
                }
                if (Number(copiedIdx) + 1 > copyCount) {
                    group.scenes.forEach(cutName => {
                        this.cutPreviewMap[cutName.toLowerCase().replace('#', '')] = null
                    })
                }
                this.generatePreviewImageURLMap(material)

                return this.setState({ material }, this.updateSceneData)
            }
        }

        if (!material.Remove) material.Remove = []
        material.Remove.push({
            Composition
        })
        this.setState({ material },this.updateSceneData)
    }

    handleClickSceneGroupRestoreMenu = () => {
        const group = this.getSelectedSceneGroup()
        if (!group || !group.scenes) return

        const sceneData = this.state.template.Scenes.find((scene) => scene.Name === group.scenes[0]);

        if (sceneData && this.getIsVideoMaxLengthExceed(sceneData.duration * sceneData.stretch)) {
            alert(i18n.t('makevideo.length.exceed.alert'));
            return
        }

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        const Composition = group.scenes[0].split('-')[0]
        this.footageCount += 1;
        const { material } = this.state
        if (!material.Remove) material.Remove = []
        for (let i = 0; i < material.Remove.length; i++) {
            // 기존에 Remove 데이터가 있을경우 제거
            if (material.Remove[i].Composition === Composition) {
                material.Remove.splice(i, 1)
                return this.setState({ material }, this.updateSceneData)
            }
        }
    }

    maintainCloseBtn = () => {
        this.setState({
            isServerCheck: false
        })
    }

    getGroupInfoBySceneIndex = index => {
        const { sceneGroups } = this.state
        let groupIdx = 0, elementId = null

        if (Array.isArray(sceneGroups)) {
            let curIdx = 0
            for (let i=0; i<sceneGroups.length; i++) {
                const { scenes } = sceneGroups[i]
                for (let j = 0; j < scenes.length; j++) {
                    if (curIdx === index) {
                        groupIdx = i
                        elementId = `group-${i}`
                        break
                    }
                    curIdx++
                }
                if (elementId) break
            }
        }
        return { groupIdx, elementId }
    }

    selectScene = index => {
        const { groupIdx, elementId } = this.getGroupInfoBySceneIndex(index)
        let { selectedLayer, isTextLayer, compName } = this.getCurrentSceneTextLayerInfo(this.state.template, index);

        this.setState({ selectedIndex: index, selectedLayer, isTextLayer, selectedSceneGroupIndex: groupIdx, selectedSceneGroupElementId: elementId },()=>{
            if (this.state.selectedMenu === "font") {
                if (compName && this.getFontPaletteAvaliableCheck() && this.state.isTextLayer) {
                    this.handleFocusTextArea(compName)
                } else {
                    this.changeMenu("workspace")
                }
            }
        });
    }
    selectBeforeScene = () => {
        this.selectScene(Math.max(this.state.selectedIndex - 1, 0))
    }
    selectAfterScene = () => {
        this.selectScene(Math.min(this.state.selectedIndex + 1, this.state.template.Scenes.length - 1))
    }
    handleChangedSliderValue = (data) => {
        const { value } = data
        if (!isNaN(value)) {
            this.selectScene(value)
        }
    }
    selectLayer = (layerIndex) => {
        this.setState({ selectedLayer: layerIndex });
    }
    addTextToMaterial = (comp, text) => {
        this.lastUpdated = Date.now()
        var material = { ...this.state.material };
        this.setState({ saveState: 'available' })

        //Update!
        for (var i = 0; i < this.state.material.Text.length; i++) {
            if (this.state.material.Text[i].Composition === comp) {
                material.Text[i].Context = text;
                this.setState(material);
                //this.state.material.Text[i].Context = context;
                return;
            }
        }
        //New!!
        material.Text.push({ Composition: comp, Context: text });
        this.setState(material);
    }

    applyTextFontOption = (comp, option, isSetCurrentTextOption = true) => {
        this.lastUpdated = Date.now()
        var material = { ...this.state.material };
        this.setState({ saveState: 'available' })
        for (var i = 0; i < this.state.material.Text.length; i++) {
            if (this.state.material.Text[i].Composition === comp) {
                if (material.Text[i].option) material.Text[i].option = { fontSize: 0, ...material.Text[i].option, ...option }
                else material.Text[i].option = option;
                this.setState(material)
                if (isSetCurrentTextOption) this.setState({ currentTextOption: { fontSize: 0, ...option } })
                return;
            }
        }
        material.Text.push({ Composition: comp, Context: '', option });
        this.setState(material);
        if (isSetCurrentTextOption) this.setState({ currentTextOption: { fontSize: 0, ...option } })
    }

    replaceAllTextFontOption = newFont => {
        let { template } = this.state
        template.Scenes.forEach(scene => {
            scene.Layers.forEach(layer => {
                const { Name: comp, Type } = layer
                if (Type === 'Text') {
                    if (!newFont) this.applyTextFontOption(comp, { Font: undefined }, false)
                    else this.applyTextFontOption(comp, { Font: { postscriptName: newFont.postscriptName, customFont: newFont.customFont } }, false)
                }
            })
        })
    }

    addFootageToMaterial = ({ comp, file, name, meta , videoThumbnail, imageThumbnail }) => {
        this.lastUpdated = Date.now()
        var material = { ...this.state.material };
        this.setState({ saveState: 'available' })
        if (this.fileObj[comp]) this.fileObj[comp] = file
        
        if (typeof this.previewImageURL[comp] === 'string' && this.previewImageURL[comp].startsWith('blob:')) {
            URL.revokeObjectURL(this.previewImageURL[comp])
            delete this.previewImageURL[comp]
        }
        if (this.deletedCompFile[comp]) delete this.deletedCompFile[comp];
        // IMAGE
        if (meta.source === "image" && file instanceof File && imageThumbnail instanceof File) {
            this.previewImageURL[comp] = URL.createObjectURL(imageThumbnail)
        }
        // if (!meta && file instanceof File) {
        //     this.previewImageURL[comp] = URL.createObjectURL(file)
        // }
        // VIDEO
        else if (file instanceof File && videoThumbnail instanceof File) {
            this.previewImageURL[comp] = URL.createObjectURL(videoThumbnail)
        }
        //Update!
        for (var i = 0; i < this.state.material.Footage.length; i++) {
            if (this.state.material.Footage[i].Composition === comp) {

                material.Footage[i].Replace = name;
                material.Footage[i].Meta = meta;
                material.Footage[i].File = file;
                material.Footage[i].VideoThumbnail = videoThumbnail;
                material.Footage[i].ImageThumbnail = imageThumbnail;
                this.modifiedMap[comp] = true;
                this.setState(material);
                return;
            }
        }
        //New!!
        material.Footage.push({ Composition: comp, File: file, Replace: name, Meta: meta, VideoThumbnail: videoThumbnail, ImageThumbnail: imageThumbnail });
        this.modifiedMap[comp] = true;
        this.setState(material);
    }

    addPaletteItem = (paletteItem) => {
        const inputItem = {
            src: paletteItem.src,
            file: paletteItem.file,
            name: paletteItem.name,
            type: paletteItem.type,
            isLocal: paletteItem.isLocal,
            thumbnail: paletteItem.thumbnail || null,
            provider: paletteItem.provider || null,
            selectedTab: paletteItem.selectedTab,
            selectedMenu: paletteItem.selectedMenu,
            data: paletteItem.data || null
        }
        this.palette.push(inputItem);
    }

    removePaletteItem = (name) => {
        var item = this.getPaletteItem(name);
        if (item) {
            var index = this.palette.indexOf(item);
            if (index !== -1) {
                this.palette.splice(index, 1);
            }
        }
    }

    removeAllPaletteItem = () => {
        this.palette = [];
    }

    getPaletteItem = (name) => {
        return this.palette.find((f) => { return f.name === name; });
    }

    handlePaymentAlertDialogOpen = () => {
        this.setState({ isPaymentAlertDialogOpen: true })
    }
    cropImage = async (item, compName, ratio, layerIndex, cb) => {
        if (!item) return;
        if (this.fileObj[compName]) delete this.fileObj[compName]
        const { template: { Scenes }, selectedIndex } = this.state
        const scene = Scenes[selectedIndex]

        // NOTE :: 가끔 AVLayer의 길이가 Cut 컴포지션보다 더 긴 경우가 있기 때문에 scene.duration을 사용해야하겠지만.. ??
        let cropDuration = scene.Layers[layerIndex].Duration
        //let cropDuration = scene.duration
        if (scene.stretch) cropDuration *= scene.stretch

        if (item.type === 'image') {
            try {
                let data = {};
                if (item.isLocal) {
                    data.fileType = item.file.type    
                    data.url = item.src
                }
                else data = await this.getBlobURLFromImageURL(item.src);
                
                if (data) {
                    this.setState({
                        isCropped: true,
                        cropSrc: data.url,
                        cropFileType:data.fileType,
                        cropComplete: cb,
                        cropBlobData: data.blob,
                        cropAspect: ratio,
                        cropDuration,
                        cropType: 'image',
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }
        else if (item.type === 'third-party-image') {
            try {
                const { fileType, url, blob } = await this.getBlobURLFromImageURL(item.src)
                this.setState({
                    isCropped: true,
                    cropSrc: url,
                    cropFileType: fileType,
                    cropComplete: cb,
                    cropBlobData: blob,
                    cropAspect: ratio,
                    cropDuration,
                    cropType: 'image'
                });
            } catch (e) {
                console.error(e);
            }
        }
        else if (item.type === 'gettyimages_image') {
            try {
                const blobURL = await this.getBlobURLFromGettyImagesId(item.name)
                this.setState({
                    isCropped: true,
                    cropSrc: blobURL,
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropDuration,
                    cropType: 'image',
                 
                });
            } catch (e) {
                console.error(e);
            }
        }
        else if (item.type === 'video') {
            if (item.isLocal){
                var paletteItem = this.getPaletteItem(item.name);
                let dataurl = paletteItem.src
                this.setState({
                    isCropped: true,
                    cropFile: paletteItem.file,
                    cropSrc: dataurl.replace('video/quicktime', 'video/mp4'),
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropFileType: paletteItem.file.type,
                    cropDuration,
                    cropType: 'video',
                    cropUploadType:"local"
                });
            }
            else {
                const { dataUrl, blob } = await this.getBlobURLFromVideo(item.src);
                this.setState({
                    isCropped: true,
                    cropSrc: dataUrl.replace('video/quicktime', 'video/mp4'),
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropFileType: blob.type,
                    cropBlobData: blob,
                    cropDuration,
                    cropType: 'video',
                    cropUploadType:"cloud"
                });
            }
           
        }
        else if (item.type === 'gettyimages') {
            this.setState({
                isCropped: true,
                cropSrc: item.file,
                cropComplete: cb,
                cropAspect: ratio,
                cropFileName: item.name,
                cropFileType: 'mp4',
                cropDuration,
                cropType: 'gettyimages'
            });
        }
        else if (item.type === 'gettyimages_video') {
            const { dataUrl, blob } = await this.getBlobURLFromGettyVideosId(item.name)
            this.setState({
                isCropped: true,
                cropSrc: dataUrl,
                cropBlobData: blob,
                cropComplete: cb,
                cropAspect: ratio,
                cropFileName: item.name,
                cropFileType: 'video/mp4',
                cropDuration,
                cropType: 'gettyimages_video'
            });
        }
    }

    cropImageFromWorkspace = async (item, compName, ratio, layerIndex, cb) => {
        try {
            if (this.fileObj[compName]) delete this.fileObj[compName]
            const { template: { Scenes }, selectedIndex } = this.state
            const scene = Scenes[selectedIndex]
    
            // NOTE :: 가끔 AVLayer의 길이가 Cut 컴포지션보다 더 긴 경우가 있기 때문에 scene.duration을 사용해야하겠지만.. ??
            let cropDuration = scene.Layers[layerIndex].Duration
            //let cropDuration = scene.duration
            if (scene.stretch) cropDuration *= scene.stretch
    
            const isFreeStock = item.type === MYSOURCE_SOURCE_TYPE.STOCK_IMAGE && (item.provider === MYSOURCE_PROVIDER_TYPE.PIXABAY || item.provider === MYSOURCE_PROVIDER_TYPE.PEXELS || item.provider === MYSOURCE_PROVIDER_TYPE.UPSPLASH);
            const isGettyImage = item.type === MYSOURCE_SOURCE_TYPE.STOCK_IMAGE && item.provider === MYSOURCE_PROVIDER_TYPE.GETTYIMAGES;
            const isGettyVideo = item.type === MYSOURCE_SOURCE_TYPE.STOCK_VIDEO && item.provider === MYSOURCE_PROVIDER_TYPE.GETTYIMAGES;
            if (item.type === MYSOURCE_SOURCE_TYPE.IMAGE) {
                const data = await this.getBlobURLFromImageURL(item.url);
                if (!data) return;

                this.setState({
                    isCropped: true,
                    cropSrc: data.url,
                    cropFileType: data.fileType,
                    cropComplete: cb,
                    cropBlobData: data.blob,
                    cropAspect: ratio,
                    cropDuration,
                    cropType: 'image',
                });
            }
            else if (isFreeStock) {
                const { fileType, url, blob } = await this.getBlobURLFromImageURL(item.url);
                this.setState({
                    isCropped: true,
                    cropSrc: url,
                    cropFileType: fileType,
                    cropComplete: cb,
                    cropBlobData: blob,
                    cropAspect: ratio,
                    cropDuration,
                    cropType: 'image'
                });
            }
            else if (isGettyImage) {
                const blobURL = await this.getBlobURLFromGettyImagesId(item.providerData.image_id)
                this.setState({
                    isCropped: true,
                    cropSrc: blobURL,
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropDuration,
                    cropType: 'image',
                });
            }
            else if (item.type === MYSOURCE_SOURCE_TYPE.VIDEO) {
                const { dataUrl, blob } = await this.getBlobURLFromVideo(item.url);
                this.setState({
                    isCropped: true,
                    cropSrc: dataUrl.replace('video/quicktime', 'video/mp4'),
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropFileType: blob.type,
                    cropBlobData: blob,
                    cropDuration,
                    cropType: 'video',
                    cropUploadType: "cloud"
                });
            }
            // else if (item.type === 'gettyimages') {
            //     this.setState({
            //         isCropped: true,
            //         cropSrc: item.file,
            //         cropComplete: cb,
            //         cropAspect: ratio,
            //         cropFileName: item.name,
            //         cropFileType: 'mp4',
            //         cropDuration,
            //         cropType: 'gettyimages'
            //     });
            // }
            else if (isGettyVideo) {
                const { dataUrl, blob } = await this.getBlobURLFromGettyVideosId(item.providerData.id)
                this.setState({
                    isCropped: true,
                    cropSrc: dataUrl,
                    cropBlobData: blob,
                    cropComplete: cb,
                    cropAspect: ratio,
                    cropFileName: item.name,
                    cropFileType: 'video/mp4',
                    cropDuration,
                    cropType: 'gettyimages_video'
                });
            }
        } catch (e) {
            ErrorHandler(this, null, e, { alert: true, log: true })
        }
    }

    clickImage = async (footage, compName, ratio, layerIndex, cb) => {
        //이미 handleDownloadSource를 호출해서 파일이 삭제된걸 확인한 경우
        if (this.deletedCompFile[compName]) return alert(i18n.t("makevideo.alert.notfound"));

        this.setState({ isImageLoading: true });
        await this.handleDownloadSource(footage)
        if (this.deletedCompFile[compName]) return alert(i18n.t("makevideo.alert.notfound"));
        const { template: { Scenes }, selectedIndex } = this.state
        const scene = Scenes[selectedIndex]
        let cropDuration = scene.Layers[layerIndex].Duration
        if (scene.stretch) cropDuration *= scene.stretch

        const url = URL.createObjectURL(this.fileObj[compName])
        const fileType = this.fileObj[compName].type
        const type = this.fileObj[compName].type.split('/')[0]
        let blobData

        const { blob } = await this.getBlobURLFromImageURL(url, false);
        blobData = blob;
        
        let cropMetaData = null;
        if (footage.Meta && footage.Meta.crop) {
            cropMetaData = footage.Meta;
        }
        
        this.setState({
            isCropped: true,
            cropSrc: url,
            cropFileType: fileType,
            cropComplete: cb,
            cropBlobData: blobData,
            cropAspect: ratio,
            cropDuration,
            cropType: type,
            cropMetaData,
            isImageLoading: false
        })
    }
    
    loadWavesurfer = (musicInfo) => {
        if (this.waveformRef) {
            ReactDOM.unmountComponentAtNode(this.waveformRef)
            this.waveformRef = null
        }

        if (this.wavesurfer) {
            this.wavesurfer.empty()
            this.wavesurfer = null
        }

        this.waveformRef = document.createElement('DIV')
        const options = formWaveSurferOptions(this.waveformRef)
        this.wavesurfer = WaveSurfer.create(options)
        this.wavesurfer.on('ready', () => {
            this.setState({ isReadyWavesurfer: true })
        })
        this.wavesurfer.on('error', (e) => {
            alert(i18n.t('makevideo.musicpalette.failure.load.wavedata'))
            this.setState({ isCropped: false, isReadyWavesurfer: false })
        })
        this.wavesurfer.load(musicInfo.url)
    }

    handleClickMusic = async (data) => {
        const { musicInfo, isCustom } = data
        const { videoUrl, templateOrigin, lang, calculatedVideoLength } = this.state

        let videoSrc = ``
        // 템플릿을 수정하고 렌더링한 비디오가 있는 경우
        if (videoUrl) {
            videoSrc = videoUrl
        }
        // 아직 렌더링한 비디오가 없는 경우
        else {
            videoSrc = TemplateHelper.getPreviewVideo(templateOrigin, lang) || ''
        }
        musicInfo.isCustom = isCustom

        // 비디오의 길이가 음악보다 길면 Notice 다이얼로그 먼저 띄움
        const isDirectOpenEditDialog = musicInfo.time >= calculatedVideoLength

        // 음악 파형 데이터 로드 (경고창 없이 팝업이 바로 열리는 경우)
        if (isDirectOpenEditDialog) this.loadWavesurfer(musicInfo)

        // 음악 길이 비교
        this.setState({
            isReadyWavesurfer: false,
            isCropped: isDirectOpenEditDialog,
            isOpenMusicLengthNoticeDialog: !isDirectOpenEditDialog,
            cropSrc: musicInfo.url, // 음악 소스 (URL)
            cropSrcInfo: musicInfo,
            cropDuration: null, // null이면 알아서 음악 길이를 추출함
            cropComplete: this.handleEditVideoMusic,
            cropFileName: musicInfo.name,
            cropFileType: '',
            cropType: 'music',
            cropDes: videoSrc, //"https://videomonsterpublicdev.blob.core.windows.net/5f55a8998c4515004b695e1e/result.mp4", // 비디오 소스
            cropDesDuration: calculatedVideoLength // null이면 알아서 음악 길이를 추출함
        });
    }

    handleClickReturnToDefaultMusicBtn = async () => {
        this.setState({ isOpenReturnToDefaultMusicDialog: true })
    }

    cropPopupClose = () => {
        this.setState({
            isCropped: false,
            cropSrc: '',
            cropComplete: null,
            cropAspect: 0,
            cropType: '',
            cropBlobData: null,
            cropUploadType: null,
            cropMetaData: null
        })
    }

    readImageFileToDataURLAsync = file => {
        return new Promise(async (resolve, reject) => {
            this.setState({ isImageLoading: true })
            try {
                const data = await LoadImage(file, { canvas: true })
                data.image.toBlob(blob => {
                    resolve(URL.createObjectURL(blob))
                    this.setState({ isImageLoading: false })
                })
            }
            catch (e) {
                this.setState({ isImageLoading: false })
                reject(e)
            }
        })
    }

    readVideoFileToDataURLAsync = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    getBlobURLFromGettyImagesId = async id => {
        let val = null
        this.setState({ isImageLoading: true })

        try {
            const data = { id, useCredit: false }
            const imageResponse = await ProviderApis.GetGettyImagesImagesDirectDownload(TokenHelper.GetToken(), data)
            val = URL.createObjectURL(imageResponse.data)
        }
        catch (e) {

        }

        this.setState({ isImageLoading: false })
        return val
    }


    getBlobURLFromGettyVideosId = async id => {
        let val = null
        let blob = null
        this.setState({ isImageLoading: true })

        try {
            const data = { id, useCredit: false }
            const videoResponse = await ProviderApis.GetGettyImagesVideosDownloadLink(TokenHelper.GetToken(), data)
            const response = await axios.get(videoResponse.data.uri, { responseType: 'blob' })
            val = URL.createObjectURL(response.data)
            blob = response.data
        }
        catch (e) {

        }

        this.setState({ isImageLoading: false })
        return { dataUrl: val, blob }
    }

    getBlobURLFromImageURL = async (src, isLoading = true) => {
        let val = null;
        let blob = null;
        let fileType;
        if (isLoading) this.setState({ isImageLoading: true })
        try {
            const response = await axios.get(src, { responseType: 'blob' })
            val = URL.createObjectURL(response.data)
            blob = response.data;
            fileType = response.data.type
        }
        catch (e) {

        }

        if (isLoading) this.setState({ isImageLoading: false })
        return { url: val, fileType, blob };
    }

    getBlobURLFromVideo = async src => {
        let val = null
        let blob = null
        this.setState({ isImageLoading: true })
        try {
            const response = await axios.get(src, { responseType: 'blob' })
            val = URL.createObjectURL(response.data)
            blob = response.data;
        }
        catch (e) {

        }

        this.setState({ isImageLoading: false })
        return { dataUrl: val, blob }
    }


    fetchPreviewsFromServer = async () => {
        try {
            const response = await axios.get(`${GetBaseUrl()}/api/video/preview/${this.getId()}`,
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                }
            )
           
            const { previews } = response.data
            this.generateCutPreviewMap(previews)

            this.setState({ previews }, this.updateSceneData)
        }
        catch (e) {

        }
    }

    fetchMaterialFromServer = async () => {
        try {
            const response = await axios.get(`${GetBaseUrl()}/api/video/preview/${this.getId()}`,
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                }
            )

            const { region } = this.state
            let { material } = response.data
            material = JSON.parse(material)

            await Promise.all(material.Footage.map(async (footage, index) => {
                const fileName = footage.File.name || footage.Replace
                if (!fileName) return
                if (footage.Meta) {
                    if (footage.Meta.source === 'gettyimages') return
                    if (!footage.VideoThumbnail || !footage.VideoThumbnail.name) return
                    const thumbnailFileName = footage.VideoThumbnail.name

                    try {
                        const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${thumbnailFileName}`, {
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('token')
                            },
                            responseType: 'blob'
                        })

                        const file = new File([response.data], thumbnailFileName, {
                            type: MimeType.lookup(thumbnailFileName)
                        })

                        material.Footage[index].VideoThumbnail = file
                    }
                    catch (e) {

                    }
                }
                else {
                    const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${fileName}`, {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('token')
                        },
                        responseType: 'blob'
                    })
                    const file = new File([response.data], footage.Replace, {
                        type: MimeType.lookup(footage.Replace)
                    })

                    material.Footage[index].File = file
                }
            }))
            this.generatePreviewImageURLMap(material)
            this.setState({ material })
        }
        catch (e) {

        }
    }

    // sendRegistNewTemplate = () =>{
    //     return new Promise(async (res,rej) => {
    //         const config = {
    //             headers: { 'Content-Type': 'application/json', 'Authorization':'Bearer ' + localStorage.getItem('token') } ,
    //         }

    //         var result = await axios.post(`${GetBaseUrl()}/api/video/regist`,{name:this.state.title, template_id:this.templateId},config);

    //         if(result.status === 200)
    //         {
    //             var newdata = this.state.template;
    //             result.data.forEach((url,index)=>{
    //                 newdata.Scenes[index].Preview = url;
    //             });
    //             this.setState({template:newdata});
    //             res(result.data);
    //         }
    //        });
    // }

    currentFiles
    uploadMyFont = inputRef => async e => {
        const { isFontFileUploading } = this.state
        const { currentUser } = this.props
        if (!currentUser || isFontFileUploading) return

        // 파일을 못찾앗거나 선택하지 않은 경우
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) return

        const token = localStorage.getItem('token')
        try {
            // 30MB
            const sizeLimit = 1024 * 1024 * 30
            for (let i = 0; i < e.target.files.length; i++) {
                var filesize = Number(e.target.files[i].size)
                if (filesize > sizeLimit) {
                    return alert(i18n.t("fontpalette.custom.alert.exceed.size"))
                }
            }
            this.setState({ isFontFileUploading: true, fontFileUploadProgress: 0 })
            this.currentFiles = e.target.files

            const userid = currentUser._id
            // 업로드 요청 생성 (중복방지를 위해 순차 처리)
            for (let i = 0; i < this.currentFiles.length; i++) {
                const form = new FormData()
                form.append('userid', userid)
                form.append('source', this.currentFiles[i])

                const config = {
                    headers: { Authorization: `Bearer ${token}` },
                    onUploadProgress: progressEvent => {
                        this.setState({ fontFileUploadProgress: (progressEvent.loaded / progressEvent.total) * 100 })
                    }
                }
                await axios.post(`${GetDefaultUrl()}/api/font/myfont-upload?id=${this.getId()}`, form, config)
            }
        }
        catch (e) {
            alert(i18n.t("makevideo.font.upload.failed"))
        }

        try {
            const fontResponse = await axios.get(`${GetBaseUrl()}/api/font/myfont`, { headers: { Authorization: `Bearer ${token}` } })
            if (fontResponse && fontResponse.data && fontResponse.data.list) {
                this.setState({ myFontList: fontResponse.data.list })
            }
        }
        catch (e) {

        }

        if (inputRef) inputRef.value = ''
        this.currentFiles = null
        this.setState({ isFontFileUploading: false })
    }

    deleteMyFont = async id => {
        try {
            const token = localStorage.getItem('token')
            await axios.delete(`${GetDefaultUrl()}/api/font/myfont/${id}`, { headers: { Authorization: `Bearer ${token}` } })

            const { myFontList } = this.state
            this.setState({ myFontList: myFontList.filter(item => item._id !== id) })
        }
        catch (e) {
            alert(i18n.t("makevideo.font.delete.failed"))
        }
    }

    sendPreviewRequest = async (uploadProgress) => {
        try {
            if (this.state.isWaitForPreview) return
            if (!this.props.currentUser.admin) {
                if (Date.now() - this.state.lastPreviewRequestedDate < 60 * 1000) return
                if (this.getProgress() < 50) return alert(i18n.t("makevideo.alert.must.input.50%"))
            }
            if (this.isChangeRatio) await this.sendSaveTemporarilyRequest(false)
            
            this.setState({ isWaitForPreview: true });

            const _id = this.getId()
            if (!_id) {
                this.setState({
                    pathAlert: true
                })
                return;
            }

            const cutModified = {
                modified: {},
                deleted: {}
            }
            for (const key in this.cutPreviewMap) {
                if (this.cutPreviewMap[key]) {
                    const preview = this.cutPreviewMap[key]
                    const startIndex = preview.toLowerCase().indexOf('/cut')
                    const endIndex = preview.toLowerCase().indexOf('.jpg')
    
                    const cutName = preview.toLowerCase().substring(startIndex + 1, endIndex)
                    if (key !== cutName) cutModified.modified[cutName] = key
                }
                else {
                    cutModified.deleted[key] = true
                }
            }

            const copiedMaterial = JSON.parse(JSON.stringify(this.state.material))
            const sourceArray = []

            for (var i = 0; i < this.state.material.Footage.length; i++) {
                var ft = this.state.material.Footage[i];
                var copiedFt = copiedMaterial.Footage[i]
                if (this.modifiedMap[ft.Composition]) {
                    if (ft && ft.Meta && ft.Meta.source === 'gettyimages') {
                        continue
                    }
                    sourceArray.push({ comp: ft.Composition, file: ft.File, name: ft.Replace });

                    if (ft.VideoThumbnail instanceof File) {
                        sourceArray.push({ comp: null, file: ft.VideoThumbnail, name: ft.VideoThumbnail.name })
                    }

                    if (ft.ImageThumbnail instanceof File) {
                        sourceArray.push({ comp: null, file: ft.ImageThumbnail, name: ft.ImageThumbnail.name })
                    }
                }
                // server의 materialHelper.js 통과시키기 위한 로직
                // Blob 또는 File인 상태로 stringify하면 빈 JSON이 들어가서 파일이름을 인식못함
                if (ft.File) copiedFt.File = { name: ft.File.name }
                if (ft.VideoThumbnail) copiedFt.VideoThumbnail = { name: ft.VideoThumbnail.name }
                if (ft.ImageThumbnail) copiedFt.ImageThumbnail = { name: ft.ImageThumbnail.name }
            }

            const config = { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }}
            this.setState({ saveState: 'onprogress' })

            let totalUploadSize = 0
            sourceArray.forEach(({ file }) => {
                if (file && file.size) totalUploadSize += file.size
            })

            let currentUploadedSize = 0
            const onUploadProgress = progressEvent => {
                uploadProgress(((currentUploadedSize + progressEvent.loaded) / totalUploadSize) * 100)
            }
            for (let i=0; i<sourceArray.length; i++) {
                const { comp, file, name } = sourceArray[i]
                if (file) {
                    const form = new FormData()
                    form.append('source', file, name)
    
                    try {
                        await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/video/${_id}/file-upload`, form, {
                            ...config,
                            onUploadProgress
                        })
                        if (comp) delete this.modifiedMap[comp]
                    }
                    // catch 블록으로 떨어져서 실패 시 rendering 또는 save API 호출단에서 ERR_NOT_UPLOADED 반환될것임.
                    catch (e) {}
    
                    currentUploadedSize += file.size
                }
            }
          
            var result = await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/video/rendering`, {
                type: 'preview',
                _id,
                name: 'myvideo',
                lang: this.props.value,
                material: JSON.stringify(copiedMaterial),
                cutModified: JSON.stringify(cutModified),
                templateId: this.templateId
            }, config);
            this.setState({ uploadPercenage: 0, showUploadPercentage: false })

            if (result.status === 200) {
                if (Object.keys(cutModified.modified).length > 0 || Object.keys(cutModified.deleted).length > 0) {
                    await this.fetchPreviewsFromServer()
                }

                if (result.data === 'ERR_SERVER_CHECK') {
                    this.sendSaveTemporarilyRequest().catch()
                    this.getServerCheckData()
                    this.setState({
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_DISABLE_EDIT') {
                    this.setState({ saveState: 'saved' })
                    alert(i18n.t("myvideo.alert.block.edit.id"))
                    this.setState({
                        isUploaded: false,
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_WAIT_COOLTIME') {
                    this.setState({ saveState: 'saved' })
                    this.setState({
                        isUploaded: false,
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_NOT_UPLOADED') {
                    this.setState({ saveState: 'available' })
                    alert(i18n.t("makevideo.error.not.uploaded"))
                    this.fetchMaterialFromServer()
                }
                else if (result.data === 'ERR_NOT_SUPPORTED') {
                    this.setState({ saveState: 'available' })
                    alert(i18n.t("makevideo.error.not.supported"))
                    this.fetchMaterialFromServer()
                }
                else {
                    this.setState({ saveState: 'saved' })
                    this.lastUpdated = null
                    this.timer = setInterval(async () => {
                        try {
                            const config = {
                                headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
                            }

                            const previewResponse = await axios.get(`${GetOriginalBaseUrl(this.state.region)}/api/video/preview-status/${_id}`, config)
                            if (previewResponse && previewResponse.data) {
                                if (previewResponse.data.isRendering) return

                                const videoResponse = await axios.get(`${GetBaseUrl()}/api/video/preview/${_id}`, config);
                                if (videoResponse.data.previews && videoResponse.data.previews.length > 0) {
                                    this.generateCutPreviewMap(videoResponse.data.previews)
                                    this.setState({ previews: videoResponse.data.previews, isWaitForPreview: false, lastPreviewRequestedDate: Date.now() }, this.updateSceneData)
                                    clearInterval(this.timer);
                                }
                                else throw new Error()
                            }
                        }
                        catch (e) {
                            alert(i18n.t("makevideo.alert.preview.failed"))
                            this.fetchMaterialFromServer().catch(() => { })
                            this.setState({ isWaitForPreview: false, lastPreviewRequestedDate: Date.now() })
                            clearInterval(this.timer);
                        }
                    }, 5000);
                }
            }
            this.isChangeRatio = false
        }
        catch (e) {
            alert(i18n.t("makevideo.alert.preview.failed"))
            this.setState({ saveState: 'available', isWaitForPreview: false });
        }
    }
    componentWillUnmount = () => {
        window.onbeforeunload = null

        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval)
        }

        if (this.timer) {
            clearInterval(this.timer);
        }

        // const { value: lang } = this.props
        // if (lang === 'ko') {
        //     const channel = document.querySelector("#ch-plugin-core");
        //     if (channel !== null) {
        //         channel.classList.remove("hide");
        //     }
        // }
    }

    isDetectedEmptyFootage = () => {
        const { originTemplateData: { EditableData } } = this
        const { template, material } = this.state
        if (!template || !Array.isArray(template.Scenes)) return true

        const groupMap = {}
        if (EditableData && EditableData.isEditable) {
            const { groups } = EditableData

            groups.forEach(group => {
                for (const name in group.map) {
                    groupMap[name] = group
                }
            })
        }

        const removeMap = {}
        if (material && Array.isArray(material.Remove)) {
            material.Remove.forEach(item => {
                removeMap[item.Composition] = true
                const group = groupMap[item.Composition]
                if (group && group.map) {
                    for (const comp in group.map) {
                        removeMap[comp] = true
                    }
                }
            })
        }

        let isDetectedEmptyFootage = false
        template.Scenes.forEach(scene => {
            if (removeMap[scene.Name]) return
            scene.Layers.forEach(layer => {
                if (layer.Type === `Footage`) {
                    let isEmptyComposition = true
                    this.state.material.Footage.forEach(footage => {
                        if (footage.Composition == layer.Name) {
                            isEmptyComposition = false
                        }
                    })

                    if (isEmptyComposition) isDetectedEmptyFootage = true
                }
            })
        })

        return isDetectedEmptyFootage
    }

    sendRenderRequest = async () => {
        const _id = this.getId()
        if (!_id) {
            // alert('디자인 고르기 페이지 팝업에서 "편집하러 가기"를 통해 이 페이지로 오셔야 합니다')
            this.setState({
                pathAlert: true
            })
            return;
        }

        if (this.isDetectedEmptyFootage()) return alert(i18n.t("makevideo.alert.must.image"))

        await this.sendSaveTemporarilyRequest(false)

        if (this.state.isNoPayment) {
            // if (this.state.isOpenAds) {
            //     return
            // }

            // if (!window.MezzoVideoAD) {
            //     this.sendSaveTemporarilyRequest().then(() => alert(i18n.t("adsdialog.adblock.alert"))).catch()
            //     return
            // }

            axios.get(`${GetBaseUrl()}/api/video/iscanfreerendering`, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(async response => {
                    if (response && response.data) {
                        const { isCanFreeRendering } = response.data

                        if (isCanFreeRendering) {
                            this.onEnded()
                            // try {
                            //     this.setState({ isUploaded: true })
                            //     await this.sendSaveTemporarilyRequest(false)
                            //     this.setState({
                            //         isUploaded: false,
                            //         isOpenAds: true
                            //     })
                            // }
                            // catch (e) {
                            //     alert(i18n.t("myvideo.error.text"))
                            // }
                        }
                        else {
                            this.sendSaveTemporarilyRequest().then(() => alert(i18n.t("myvideo.alert.exceed.free.rendering"))).catch()
                        }
                    }
                    else {
                        alert(i18n.t("myvideo.error.text"))
                    }
                })
                .catch(e => {
                    alert(i18n.t("myvideo.error.text"))
                })
        }
        else {
            const { changeMusicInfo, calculatedVideoLength, material, isContinueShortMusic } = this.state
            const originVideoLength = this.getOriginVideoLength()

            if (changeMusicInfo) {
                if (!isContinueShortMusic && this.videoLengthWhenMusicChanged !== calculatedVideoLength && changeMusicInfo.time < calculatedVideoLength) this.setState({ isOpenMusicLengthSettingDialog: true })
                else if (!isContinueShortMusic && this.videoLengthWhenMusicChanged !== calculatedVideoLength && changeMusicInfo.time - Math.floor(material.Music.StartTime) < Math.floor(calculatedVideoLength)) this.setState({ isOpenMusicSectionSettingDialog: true })
                else this.onEnded()
            }
            else {
                if (originVideoLength && (Number(originVideoLength.toFixed(5)) < Number(calculatedVideoLength.toFixed(5)))) this.setState({ isOpenMusicLengthSettingDialog: true })
                else this.onEnded()
            }
        }
    }

    sendSaveTemporarilyRequest = async (showUploadPercentage = true, isAutoSave = false) => {
        const _id = this.getId()
        if (!_id) {
            // alert('디자인 고르기 페이지 팝업에서 "편집하러 가기"를 통해 이 페이지로 오셔야 합니다')
            this.setState({
                pathAlert: true
            })
            return;
        }

        if (this.isSaving) return
        this.isSaving = true

        try {
            const cutModified = {
                modified: {},
                deleted: {}
            }
            for (const key in this.cutPreviewMap) {
                if (this.cutPreviewMap[key]) {
                    const preview = this.cutPreviewMap[key]
                    const startIndex = preview.toLowerCase().indexOf('/cut')
                    const endIndex = preview.toLowerCase().indexOf('.jpg')
    
                    const cutName = preview.toLowerCase().substring(startIndex + 1, endIndex)
                    if (key !== cutName) cutModified.modified[cutName] = key
                }
                else {
                    cutModified.deleted[key] = true
                }
            }

            const copiedMaterial = JSON.parse(JSON.stringify(this.state.material))
            const sourceArray = []
            for (var i = 0; i < this.state.material.Footage.length; i++) {
                var ft = this.state.material.Footage[i];
                var copiedFt = copiedMaterial.Footage[i]
                if (this.modifiedMap[ft.Composition]) {
                    if (ft && ft.Meta && ft.Meta.source === 'gettyimages') {
                        continue
                    }
                    sourceArray.push({ comp: ft.Composition, file: ft.File, name: ft.Replace })
                    if (ft.VideoThumbnail instanceof File) {
                        sourceArray.push({ comp: null, file: ft.VideoThumbnail, name: ft.VideoThumbnail.name })
                    }

                    if (ft.ImageThumbnail instanceof File) {
                        sourceArray.push({ comp: null, file: ft.ImageThumbnail, name: ft.ImageThumbnail.name })
                    }
                }
                // server의 materialHelper.js 통과시키기 위한 로직
                // Blob 또는 File인 상태로 stringify하면 빈 JSON이 들어가서 파일이름을 인식못함
                if (ft.File) copiedFt.File = { name: ft.File.name }
                if (ft.VideoThumbnail) copiedFt.VideoThumbnail = { name: ft.VideoThumbnail.name }
                if (ft.ImageThumbnail) copiedFt.ImageThumbnail = { name: ft.ImageThumbnail.name }
            }

            var self = this;
            const config = {
                headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
            }
            this.setState({ saveState: 'onprogress', showUploadPercentage })

            let totalUploadSize = 0
            sourceArray.forEach(({ file }) => {
                if (file && file.size) totalUploadSize += file.size
            })

            let currentUploadedSize = 0
            const onUploadProgress = progressEvent => {
                self.setState({ uploadPercenage: ((currentUploadedSize + progressEvent.loaded) / totalUploadSize) * 100 })
            }

            for (let i=0; i<sourceArray.length; i++) {
                const { comp, file, name } = sourceArray[i]
                if (file) {
                    const form = new FormData()
                    form.append('source', file, name)
    
                    try {
                        await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/video/${_id}/file-upload`, form, {
                            ...config,
                            onUploadProgress
                        })
                        if (comp) delete this.modifiedMap[comp]
                    }
                    // catch 블록으로 떨어져서 실패 시 rendering 또는 save API 호출단에서 ERR_NOT_UPLOADED 반환될것임.
                    catch (e) {}
    
                    currentUploadedSize += file.size
                }
            }
            var result = await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/template/tempSave`, {
                type: 'video',
                _id,
                name: 'myvideo',
                material: JSON.stringify(copiedMaterial),
                cutModified: JSON.stringify(cutModified),
                templateId: this.templateId,
                isTemp: isAutoSave ? true : false
            }, config);

            if (result && result.status === 200) {
                if (Object.keys(cutModified.modified).length > 0 || Object.keys(cutModified.deleted).length > 0) {
                    await this.fetchPreviewsFromServer()
                }

                if (result.data === 'ERR_NOT_UPLOADED') {
                    alert(i18n.t("makevideo.error.not.uploaded"))
                    this.setState({ saveState: 'available' })
                    this.fetchMaterialFromServer()
                }
                else if (result.data === 'ERR_NOT_SUPPORTED') {
                    alert(i18n.t("makevideo.error.not.supported"))
                    this.setState({ saveState: 'available' })
                    this.fetchMaterialFromServer()
                }
                else if (result.data === 'ERR_INVALID_PARAM') {
                    alert(i18n.t("makevideo.error.invalid.param"))
                    this.setState({ saveState: 'available' })
                    this.fetchMaterialFromServer()
                }
                else {
                    this.lastUpdated = null
                    this.setState({
                        saveState: 'saved', isSaveTemporarilyUploaded: false
                    });
                }
            }
            else {
                alert(i18n.t("global.failed.unknown"))
                this.setState({ saveState: 'available' })
            }
        }
        catch (e) {
            alert(i18n.t("global.failed.unknown"))
            this.setState({ saveState: 'available' })
        }
        this.setState({ uploadPercenage: 0, showUploadPercentage: false })
        this.isSaving = false
    }

    changeMenu = (menu) => {
        if (menu === "font") {
            if (this.getFontPaletteAvaliableCheck()) {
                if (this.state.isTextLayer) {
                    this.selectScene(this.state.selectedIndex);
                } else {
                    return;
                }
            }
            else  {
                this.handlePaymentAlertDialogOpen()
                return;
            }
        } else if (menu === "music") {
            if (!this.state.availableFunc.MusicChange && !this.state.isVchangeUser) {
                this.handlePaymentAlertDialogOpen();
                return;
            }
        } else if (menu === "ratio") {
            if (!this.state.availableFunc.DesignChange) return this.handlePaymentAlertDialogOpen()
        } else {
            this.selectLayer(-1)
        }
        this.setState({ selectedMenu: menu });
        // if (menu === 'font' && this.getFontPaletteAvaliableCheck()) this.selectScene(this.state.selectedIndex); 
        // else if(mew) this.selectLayer(-1)
        
       
    }

    getProgress = () => {
        const { material, template } = this.state;
        return template ? Math.round(material.Footage.length / (template.ImageCount + this.footageCount) * 100) : 0;
    }
    // closeTitlePopUp = () => {
    //     this.setState({ visibleTitlePopUp: false });
    // }
    changeTitle = (event) => {
        this.setState({ title: event.target.value });
    }
    // onTitleSubmitButtonClicked = () => {
    //     if (this.state.title === "") {
    //         this.setState({ visibleTitleNull: true, title: "" });
    //         return;
    //     }
    //     const token = localStorage.getItem("token");
    //     const _id = this.getId()
    //     if (!_id) {
    //         // alert('디자인 고르기 페이지 팝업에서 "편집하러 가기"를 통해 이 페이지로 오셔야 합니다')
    //         this.setState({
    //             pathAlert: true
    //         })
    //         return;
    //     }
    //     const axiosResult = axios.post(
    //         `${GetBaseUrl()}/api/video/rename`,
    //         {
    //             _id,
    //             name: this.state.title
    //         },
    //         {
    //             headers: { Authorization: `Bearer ${token}` }
    //         }
    //     );
    //     axiosResult
    //         .then(res => {
    //             this.setState({ visibleTitlePopUp: false, title: "" });
    //         })
    //         .catch(error => {
    //             alert("비디오 rename 에러... 스크린샷으로 문의해주세요", error);
    //         });

    // }

    closeUploadCompletedDialog = (page) => (event) => {
        const _id = this.getId()
        // const { isGalleryOpen, isHideGalleryState } = this.state

        // // 선택값과 다르고, 기존 갤러리 state와 달라야함
        // if (isHideGalleryState !== this.isHideGalleryStateDefaultValue && isHideGalleryState !== !isGalleryOpen) {
        //     axios.post(`${GetBaseUrl()}/api/video/gallery-open`, { id: _id, isOpen: !isHideGalleryState }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } }).catch(e => console.log(e))
        // }

        const { isCheckGalleryUpload } = this.state

        if (isCheckGalleryUpload) {
            axios.post(`${GetBaseUrl()}/api/video/gallery-open`, { id: _id, isOpen: true, isFromEditor: true }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } }).catch(e => console.log(e))
        }

        if (page === "GoToMypage") {
            this.props.history.push(`/user/${this.props.currentUser && this.props.currentUser.email}/my-video`)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
    closeSaveTemporarilyUploadCompletedDialog = (page) => (event) => {
        this.setState({
            isSaveTemporarilyUploadedCompleted: false
        })
    }

    handleExit = () => {
        if (this.props.currentUser) {
            this.props.history.push(`/user/${this.props.currentUser && this.props.currentUser.email}/my-video`)
        }
        else {
            this.props.history.push(`/`)
        }
    }

    handleClose = () => {
        this.setState({
            isUploadCompleted: false,
        })
    }

    handleAdjustLengthAlertOpen = () => {
        // 한번 열었던 적 있으면 return
        if (localStorage.getItem('isAdjustLengthAlertOpen')) return

        localStorage.setItem('isAdjustLengthAlertOpen', true)
        this.setState({ isShowAdjustLengthAlert: true })
    }
    handleCloseAdjustLengthAlert = () => {
        this.setState({ isShowAdjustLengthAlert: false })
    }

    handleSaveTemporarilyClose = () => {
        this.setState({
            isSaveTemporarilyUploadCompleted: false
        })
    }
    handlepathAlert = () => {
        this.setState({
            pathAlert: false
        })
    }

    handleAdsClose = () => {
        // this.setState({
        //     isOpenAds: false
        // })
    }

    onEnded = async () => {
        try {
            const _id = this.getId()
            if (!_id) {
                // alert('디자인 고르기 페이지 팝업에서 "편집하러 가기"를 통해 이 페이지로 오셔야 합니다')
                this.setState({
                    pathAlert: true
                })
                return;
            }
            // this.handleAdsClose()
            
            const cutModified = {
                modified: {},
                deleted: {}
            }
            for (const key in this.cutPreviewMap) {
                if (this.cutPreviewMap[key]) {
                    const preview = this.cutPreviewMap[key]
                    const startIndex = preview.toLowerCase().indexOf('/cut')
                    const endIndex = preview.toLowerCase().indexOf('.jpg')
    
                    const cutName = preview.toLowerCase().substring(startIndex + 1, endIndex)
                    if (key !== cutName) cutModified.modified[cutName] = key
                }
                else {
                    cutModified.deleted[key] = true
                }
            }

            const copiedMaterial = JSON.parse(JSON.stringify(this.state.material))
            const sourceArray = []

            for (var i = 0; i < this.state.material.Footage.length; i++) {
                var ft = this.state.material.Footage[i];
                var copiedFt = copiedMaterial.Footage[i]
                if (this.modifiedMap[ft.Composition]) {
                    if (ft && ft.Meta && ft.Meta.source === 'gettyimages') {
                        continue
                    }
                    sourceArray.push({ comp: ft.Composition, file: ft.File, name: ft.Replace })
                    if (ft.VideoThumbnail instanceof File) {
                        sourceArray.push({ comp: null, file: ft.VideoThumbnail, name: ft.VideoThumbnail.name })
                    }

                    if(ft.ImageThumbnail instanceof File){
                        sourceArray.push({ comp: null, file: ft.ImageThumbnail, name: ft.ImageThumbnail.name })
                    }
                }
                // server의 materialHelper.js 통과시키기 위한 로직
                // Blob 또는 File인 상태로 stringify하면 빈 JSON이 들어가서 파일이름을 인식못함
                if (ft.File) copiedFt.File = { name: ft.File.name }
                if (ft.VideoThumbnail) copiedFt.VideoThumbnail = { name: ft.VideoThumbnail.name }
                if (ft.ImageThumbnail) copiedFt.ImageThumbnail = { name: ft.ImageThumbnail.name }
            }
 
            var self = this;
            this.setState({ isUploaded: true });
            this.setState({ saveState: 'onprogress' })

            const config = { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }}
            this.setState({ saveState: 'onprogress' })

            let totalUploadSize = 0
            sourceArray.forEach(({ file }) => {
                if (file && file.size) totalUploadSize += file.size
            })

            let currentUploadedSize = 0
            const onUploadProgress = progressEvent => {
                let value = ((currentUploadedSize + progressEvent.loaded) / totalUploadSize) * 100
                value = value ? value.toFixed(0) : 0
                self.setState({ uploadPercenage: value });
            }

            for (let i = 0; i < sourceArray.length; i++) {
                const { comp, file, name } = sourceArray[i]
                if (file) {
                    const form = new FormData()
                    form.append('source', file, name)
                    try {
                        await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/video/${_id}/file-upload`, form, {
                            ...config,
                            onUploadProgress
                        })
                        if (comp) delete this.modifiedMap[comp]
                    }
                    // catch 블록으로 떨어져서 실패 시 rendering 또는 save API 호출단에서 ERR_NOT_UPLOADED 반환될것임.
                    catch (e) {}
    
                    currentUploadedSize += file.size
                }
            }
        
            var result = await axios.post(`${GetOriginalBaseUrl(this.state.region)}/api/video/rendering`, {
                type: 'video',
                _id,
                name: 'myvideo',
                lang: this.props.value,
                material: JSON.stringify(copiedMaterial),
                cutModified: JSON.stringify(cutModified),
                templateId: this.templateId
            }, config);

            if (result.status === 200) {
                if (Object.keys(cutModified.modified).length > 0 || Object.keys(cutModified.deleted).length > 0) {
                    await this.fetchPreviewsFromServer()
                }

                if (result.data === 'ERR_SERVER_CHECK') {
                    this.sendSaveTemporarilyRequest().catch()
                    this.getServerCheckData()
                    this.setState({
                        isUploaded: false,
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_EXCEED_FREERENDERING') {
                    this.sendSaveTemporarilyRequest().then(() => alert(i18n.t("myvideo.alert.exceed.free.rendering"))).catch()
                    this.setState({
                        isUploaded: false,
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_DISABLE_EDIT') {
                    this.setState({ saveState: 'saved' })
                    alert(i18n.t("myvideo.alert.block.edit.id"))
                    this.setState({
                        isUploaded: false,
                        isWaitForPreview: false
                    })
                }
                else if (result.data === 'ERR_NOT_UPLOADED') {
                    this.setState({ saveState: 'available' })
                    this.setState({ isUploaded: false });
                    alert(i18n.t("makevideo.error.not.uploaded"))
                    this.fetchMaterialFromServer()
                }
                else if (result.data === 'ERR_NOT_SUPPORTED') {
                    this.setState({ saveState: 'available' })
                    this.setState({ isUploaded: false });
                    alert(i18n.t("makevideo.error.not.supported"))
                    this.fetchMaterialFromServer()
                }
                else {
                    this.lastUpdated = null
                    // const { isNoPayment, isGalleryOpen, time } = this.state

                    // if (isNoPayment) {
                    //     // 무료 사용자일 경우 초기값은 반드시 갤러리 오픈
                    //     if (time > 10 && (isGalleryOpen === true || isGalleryOpen === undefined)) {
                    //         axios.post(`${GetBaseUrl()}/api/video/gallery-open`, { id: _id, isOpen: true }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } }).catch(e => console.log(e))
                    //         this.isHideGalleryStateDefaultValue = false
                    //         this.setState({ isGalleryOpen: true })
                    //     }
                    //     else this.isHideGalleryStateDefaultValue = true
                    // }
                    // else {
                    //     this.isHideGalleryStateDefaultValue = !isGalleryOpen
                    // }

                    // this.setState({ saveState: 'saved', isUploaded: false, isUploadCompleted: true, isHideGalleryState: this.isHideGalleryStateDefaultValue });

                    if (this.state.isCheckGalleryUpload) {
                        let emptyTextCount = 0
                        copiedMaterial.Text.forEach(({ Context }) => {
                            if (typeof Context !== 'string' || Context.trim().length === 0) emptyTextCount++
                        })
                        if (emptyTextCount / copiedMaterial.Text.length > 0.5) {
                            this.setState({ isCheckGalleryUpload: false })
                        }
                    }

                    this.setState({ saveState: 'saved', isUploaded: false, isUploadCompleted: true });

                    if (mode === 'stage') {
                        // ReactGA.event({
                        //     category: 'user',
                        //     action: 'rendering'
                        // })
                        // ReactPixel.trackCustom("rendering", { category: 'user', action: 'rendering' })

                        if (Array.isArray(window.dataLayer)) {
                            window.dataLayer.push({
                                event: 'tag_rendering'
                            })
                        }
                    }

                    if (this.state.isVchangeUser) {
                        axios.post(`${GetBaseUrl()}/api/video/gallery-open`, { id: _id, isOpen: true }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } }).catch(e => console.log(e))
                    }
                }
            }
        }
        catch (e) {
            alert(i18n.t("global.failed.unknown"))
            this.setState({ saveState: 'available' })
            this.setState({ isUploaded: false });
        }
        this.setState({ uploadPercenage: 0, showUploadPercentage: false })
    }

    onTutorialClose = isSkip => e => {
        if (isSkip) {
            if (window.confirm(i18n.t("tutorial.skip.alert"))) {
                axios.post(`${GetBaseUrl()}/api/user/view-tutorial`, {}, { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } })
                    .catch(e => console.log(e))
                this.setState({ tutorialOpen: false })
            }
        }
        else {
            this.setState({ tutorialOpen: false })
        }
    }
    clickShowGallery = (e) => {
        // this.setState({
        //     isHideGalleryState: e.target.checked
        // })
        this.setState({
            isCheckGalleryUpload: e.target.checked
        })
    }

    handleClickPreviewImage = src => {
        this.setState({
            isPreviewImageOpen: true,
            previewSrc: src
        })
    }

    handleClosePreviewImage = () => {
        this.setState({
            isPreviewImageOpen: false,
            previewSrc: null
        })
    }

    handleFocusTextArea = comp => {
        const currentTextLayerAttr = { fillColor: false, strokeColor: false }
        const textInput = document.getElementById(comp);
        
        for (var i = 0; i < this.state.template.Scenes.length; i++) {
            var scene = this.state.template.Scenes[i]
            var isFind = false
            for (var j = 0; j < scene.Layers.length; j++) {
                var layer = scene.Layers[j];
                if (layer.Name === comp) {
                    isFind = true
                    if (layer.FillColor) currentTextLayerAttr.fillColor = true
                    if (layer.StrokeColor) currentTextLayerAttr.strokeColor = true
                    break
                }
            }
            if (isFind) break
        }
        this.setState({ currentTextLayerAttr })

        if (this.getFontPaletteAvaliableCheck() && this.state.isTextLayer) this.setState({ selectedMenu: "font" })

        for (var i = 0; i < this.state.material.Text.length; i++) {
            if (this.state.material.Text[i].Composition === comp) {
                const option = { ...this.state.material.Text[i].option };
                this.setState({ currentTextOption: { fontSize: 0, ...option }, selectedComposition: comp}, () => textInput && textInput.focus())
                return
            }
        }

        this.setState({ currentTextOption: { fontSize: 0 }, selectedComposition: comp }, () => textInput && textInput.focus())
    }

    handleClickFontIcon = comp => {
        if (!this.state.availableFunc.FontChange) return

        this.changeMenu('font')

        const ref = document.getElementById(comp)
        if (ref) ref.focus()
    }

    updateMaterial(material, scene, stretchRatio) {
        const { Name: Composition, Layers } = scene
        if (Array.isArray(Layers) && Array.isArray(material.Footage)) {
            for (var i = 0; i < Layers.length; i++) {
                const curLayer = Layers[i]
                if (curLayer.Type === "Footage" && curLayer.Name.toLowerCase().includes("#av")) {
                    const layerDuration = curLayer.Duration
                    for (let j = 0; j < material.Footage.length; j++) {
                        const curFootage = material.Footage[j]
                        if (curFootage.Composition === curLayer.Name && curFootage.Meta && !isNaN(curFootage.Meta.to) && !isNaN(curFootage.Meta.from)) {
                            curFootage.Meta.to = Number((curFootage.Meta.from + (layerDuration * stretchRatio)).toFixed(3))
                            this.modifiedMap[Composition] = true;
                        }
                    }
                }
            }
        }
        this.setState({ material }, this.updateSceneDuration)
    }

    handleClickLengthAdjustMinusBtn = () => {
        const { template: { Scenes }, selectedIndex, material, calculatedVideoLength, isNoPayment } = this.state
        if (isNoPayment) {
            this.setState({ isPaymentAlertDialogOpen: true });
            return
        }
        if (!Scenes[selectedIndex]) return

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        const { Name: Composition, duration } = Scenes[selectedIndex]
        const value = STRETCH_ADJUST_VALUE / duration

        if (this.videoLengthWhenContinue >= calculatedVideoLength) this.setState({ isContinueShortMusic: true })

        let stretchRatio = 1
        let isUpdated = false
        if (!material.Stretch) material.Stretch = []
        for (let i = 0; i < material.Stretch.length; i++) {
            if (material.Stretch[i].Composition === Composition) {
                const orgVal = material.Stretch[i].Stretch
                const addVal = value * 100
               
                if (orgVal < STRETCH_DECREASE_ALERT_VALUE && orgVal + addVal >= STRETCH_DECREASE_ALERT_VALUE) {
                    if (!window.confirm(i18n.t('makevideo.stretch.decrease.alert'))) return
                }

                if (orgVal - addVal < STRETCH_DECREASE_LIMIT_VALUE || orgVal - addVal <= 0) return
                
                material.Stretch[i].Stretch -= addVal;
                stretchRatio = material.Stretch[i].Stretch / 100
                isUpdated = true
                break
            }
        }

        if (!isUpdated) {
            stretchRatio = 100 - (value * 100)
            material.Stretch.push({
                Composition,
                Stretch: 100 - (value * 100)
            })
        }

        this.updateMaterial(material, Scenes[selectedIndex], stretchRatio)
    }

    handleClickLengthAdjustPlusBtn = () => {
        const { template: { Scenes }, selectedIndex, material, isPremium, calculatedVideoLength, isNoPayment } = this.state
        if (isNoPayment) {
            this.setState({ isPaymentAlertDialogOpen: true });
            return
        }
        if (!Scenes[selectedIndex]) return

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        const { Name: Composition, duration } = Scenes[selectedIndex]
        const value = STRETCH_ADJUST_VALUE / duration

        if (this.videoLengthWhenContinue < calculatedVideoLength) this.setState({ isContinueShortMusic: false })

        let stretchRatio = 1
        let isUpdated = false
        if (!material.Stretch) material.Stretch = []
        for (let i = 0; i < material.Stretch.length; i++) {
            if (material.Stretch[i].Composition === Composition) {
                const orgVal = material.Stretch[i].Stretch
                const addVal = value * 100

                if (this.getIsVideoMaxLengthExceed(duration * (((orgVal + addVal) / 100) - (orgVal / 100)))){
                    alert(i18n.t('makevideo.length.exceed.alert'));
                    return
                }

                if (orgVal < STRETCH_INCREASE_ALERT_VALUE && orgVal + addVal >= STRETCH_INCREASE_ALERT_VALUE) {
                    if (!window.confirm(i18n.t('makevideo.stretch.increase.alert'))) return
                }

                if (!isPremium && orgVal + addVal > STRETCH_INCREASE_LIMIT_VALUE) return

                
                material.Stretch[i].Stretch += addVal
                stretchRatio = material.Stretch[i].Stretch / 100
                isUpdated = true
                break
            }
        }

        if (!isUpdated) {
            stretchRatio = 100 + (value * 100)
            material.Stretch.push({
                Composition,
                Stretch: stretchRatio
            })
        }

        this.updateMaterial(material, Scenes[selectedIndex], stretchRatio)
    }

    handleClickLengthAdjustResetBtn = () => {
        const { template: { Scenes }, selectedIndex, material,isNoPayment } = this.state

        if (isNoPayment) {
            this.setState({ isPaymentAlertDialogOpen: true });
            return
        }

        if (!Scenes[selectedIndex]) return

        this.lastUpdated = Date.now()
        this.setState({ saveState: 'available' })

        const { Name: Composition, duration } = Scenes[selectedIndex]
        const stretchValue = 100
        const stretchRatio = stretchValue / 100

        if (Array.isArray(material.Stretch)) {
            for (let i = 0; i < material.Stretch.length; i++) {
                if (material.Stretch[i].Composition === Composition) {
                    if (material.Stretch[i].Stretch < 100 && this.getIsVideoMaxLengthExceed(duration * (100 - material.Stretch[i].Stretch) / 100)) {
                        alert(i18n.t('makevideo.length.exceed.alert'));
                        return
                    }
                  
                    material.Stretch[i].Stretch = stretchValue
                    break
                }
            }
        }

        this.updateMaterial(material, Scenes[selectedIndex], stretchRatio)
    }

    handleEditVideoMusic = (musicInfo, isCustom, fadeDuration, videoStartTime, volume, blobURL) => {
        /*
        Materisl: {
            Music: {
                Custom: boolean, (true인 경우 UserPath, false인 경우 GlobalPath) 
                Replace: string, (fileName) 
                Name: string (음악 제목)
                Provider: string, (artlist)
                FadeDuration: float, (페이드 인/아웃 적용 시간) >> 1초 고정 
                StartTime: float (음악이 시작되는 시간) 
            }
        }
        */
        const { material, calculatedVideoLength } = this.state
        this.lastUpdated = Date.now()
        this.videoLengthWhenMusicChanged = calculatedVideoLength
        material.Music = {
            blobURL,
            Custom: isCustom,
            Replace: musicInfo.filename,
            Name: musicInfo.name,
            Provider: isCustom ? null : musicInfo.provider,
            FadeDuration: fadeDuration,
            StartTime: videoStartTime,
            Volume: volume
        }
        if (isCustom) material.Music._id = musicInfo._id;
        this.setState({ material, changeMusicInfo: musicInfo })
    }

    handleCloseMusicLengthNoticeDialog = () => {
        this.setState({ isCropped: false, isOpenMusicLengthNoticeDialog: false })
    }

    handleContinueMusicLengthNoticeDialog = () => {
        const { cropSrcInfo, calculatedVideoLength } = this.state
        this.loadWavesurfer(cropSrcInfo)
        this.setState({ isCropped: true, isOpenMusicLengthNoticeDialog: false, isReadyWavesurfer: false, isContinueShortMusic: true })
        this.videoLengthWhenContinue = calculatedVideoLength
    }

    handleCloseReturnToDefaultMusicDialog = () => {
        this.setState({ isOpenReturnToDefaultMusicDialog: false })
    }

    handleConfirmReturnToDefaultMusicDialog = () => {
        const { material } = this.state;
        material.Music = null;
        this.setState({ material, isOpenReturnToDefaultMusicDialog: false, changeMusicInfo: null });
    }

    handleChangeCashedMediaInfoMap = (cashedMediaInfoMap) => {
        this.cashedMediaInfoMap = cashedMediaInfoMap
    }
    
    handleCompleteMusicLengthSettingDialog = () => {
        this.setState({ isOpenMusicLengthSettingDialog: false })
        this.onEnded()
    }

    handleResetMusicLengthSettingDialog = () => {
        this.setState({ isOpenMusicLengthSettingDialog: false, selectedMenu: 'music' })
    }

    handleCompleteMusicSectionSettingDialog = () => {
        this.setState({ isOpenMusicSectionSettingDialog: false })
        this.onEnded()
    }

    handleResetMusicSectionSettingDialog = () => {
        const { changeMusicInfo, videoUrl, templateOrigin, lang, calculatedVideoLength } = this.state
        let videoSrc = ``
        if (videoUrl) {
            videoSrc = videoUrl
        }
        else {
            videoSrc = TemplateHelper.getPreviewVideo(templateOrigin, lang) || ''
        }

        this.loadWavesurfer(changeMusicInfo)
        this.setState({ 
            isCropped: true, 
            cropSrc: changeMusicInfo.url,
            cropSrcInfo: changeMusicInfo,
            cropDuration: null,
            cropComplete: this.handleEditVideoMusic,
            cropFileName: changeMusicInfo.name,
            cropFileType: '',
            cropType: 'music',
            cropDes: videoSrc,
            cropDesDuration: calculatedVideoLength,
            isOpenMusicSectionSettingDialog: false, 
            isReadyWavesurfer: false, 
            selectedMenu: 'music' })
    }
    
    handleClickOtherRatio = async (ratio, beforeRatio) => {
        const { groupData, isWaitForPreview } = this.state
        const templateId = groupData[ratio]._id
        
        if (isWaitForPreview) return this.setState({ isUnavailableDialogOpen: true })
        if (this.lastUpdated !== null) {
            if (window.confirm(i18n.t("makevideo.ratiopalette.confirm.text"))) await this.sendSaveTemporarilyRequest(false)
            else return
        }
        this.templateId = templateId
        this.setState({ selectedRatio: ratio, isLoading: true })
        try {
            const token = DataManager.GetToken()
            const { result, data } = await VideosApis.GetChangeTemplateInfo(token, { videoId: this.getId(), templateId })
            this.isChangeRatio = true

            if (!result) throw new Error()
            
            let { template, material: oldMaterial } = data
            const { region } = this.state
            this.originTemplateData = JSON.parse(JSON.stringify(template))
            const previews = template.Scenes.map((item) => item.Preview)
            this.generateCutPreviewMap(previews)

            if (oldMaterial) {
                oldMaterial = JSON.parse(oldMaterial)

                // 템플릿에 적용된 커스텀 음악이 나의 음악에 등록되어 잇는지 확인
                if (oldMaterial.Music && oldMaterial.Music.Replace) {
                    const url = oldMaterial.Music.blobURL
                    const name = oldMaterial.Music.Name
                    const provider = oldMaterial.Music.Provider
                    const isCustom = oldMaterial.Music.Custom

                    try {
                        // 음악 파일을 찾은 경우 그대로 고고
                        const response = await axios.get(url, { responseType: 'blob' })
                        const contentType = response.headers['content-type']
                        const firstType = contentType.split("/")[0]

                        // 컨텐츠 형식이 audio가 아니면 Material.Music 초기화
                        if (firstType !== 'audio') { oldMaterial.Music = null }
                        else this.setState({ changeMusicInfo: { url, name, provider, isCustom } })
                    }
                    catch (e) {

                        // 음악 파일을 찾지 못한 경우 Material.Music 초기화
                        oldMaterial.Music = null
                    }
                }

                if (oldMaterial.Footage) {
                    await Promise.all(oldMaterial.Footage.map(async (footage, index) => {
                        const fileName = footage.File.name || footage.Replace
                        if (!fileName) return
                        if (footage.Meta) {
                            if (footage.Meta.source === 'gettyimages') return


                            if ((!footage.VideoThumbnail || !footage.VideoThumbnail.name) && (!footage.ImageThumbnail || !footage.ImageThumbnail.name)) return
                            const isImageSource = footage.Meta.source === "image";
                            let thumbnailFileName = isImageSource ? footage.ImageThumbnail.name : footage.VideoThumbnail.name
                            try {
                                const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${thumbnailFileName}`, {
                                    headers: {
                                        Authorization: 'Bearer ' + localStorage.getItem('token')
                                    },
                                    responseType: 'blob'
                                })

                                const file = new File([response.data], thumbnailFileName, {
                                    type: MimeType.lookup(thumbnailFileName)
                                })
                                if (isImageSource) oldMaterial.Footage[index].ImageThumbnail = file
                                else oldMaterial.Footage[index].VideoThumbnail = file
                            }
                            catch (e) {
                                console.dir(e)
                            }
                        }
                        else {
                            const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${fileName}`, {
                                headers: {
                                    Authorization: 'Bearer ' + localStorage.getItem('token')
                                },
                                responseType: 'blob'
                            })

                            const file = new File([response.data], footage.Replace, {
                                type: MimeType.lookup(footage.Replace)
                            })

                            oldMaterial.Footage[index].File = file
                        }
                    }))
                    this.generatePreviewImageURLMap(oldMaterial);

                    template.Scenes.forEach(scene => {
                        scene.Layers.forEach(layer => {
                            if (layer.Type === `Text`) {
                                let isEmptyComposition = true
                                oldMaterial.Text.forEach(text => {
                                    if (text.Composition == layer.Name) {
                                        isEmptyComposition = false
                                        if (layer.Text) {
                                            text.Placeholder = layer.Text
                                        }
                                    }
                                })

                                if (isEmptyComposition) {
                                    oldMaterial.Text.push({
                                        Composition: layer.Name,
                                        Context: ``,
                                        Placeholder: layer.Text
                                    })
                                }
                            }
                        })
                    })
                    this.setState({ material: oldMaterial });
                }
            }
            this.setState({ template, isLoading: false }, this.updateSceneData)
        }
        catch (e) {
            const userId = this.props.currentUser ? this.props.currentUser._id : ''
            ErrorHandler(this, userId, e, { alert: true, server: true })
            this.setState({ isLoading: false, selectedRatio: beforeRatio })
        }
    }

    handleDownloadSource = async footage => {
        const { region } = this.state
        if (this.fileObj[footage.Composition] instanceof File) return
        else if (footage.File instanceof File) {
            this.fileObj[footage.Composition] = footage.File
            return
        }
        try {
            const fileName = footage.File.name || footage.Replace
            if (!fileName) return

            const response = await axios.get(`${GetOriginalBaseUrl(region)}/api/video/download/${this.getId()}/${fileName}`, {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                responseType: 'blob'
            })

            const file = new File([response.data], footage.Replace, {
                type: MimeType.lookup(footage.Replace)
            })
            this.fileObj[footage.Composition] = file
        } catch (e) {
            const publicErrorCode = GetPublicErrorCode(e);
            if (publicErrorCode === PUBLIC_ERROR_CODE.HTTP_STATUS_404) this.deletedCompFile[footage.Composition] = true;
            this.setState({ isImageLoading: false })
        }
    }

	handleClickAiTool = (tool) => {
		this.setState({ selectedAiTool: tool})
	}

    forceUpdate = () => {
        this.setState({ now: Date.now() });
    }

    render() {
        const videoLength = this.state.calculatedVideoLength
        const { isReadyWavesurfer, availableFunc, isVchangeUser, selectedSceneGroupElementId, isEditableApproved, templateOrigin, selectedIndex, template, isLoading, isUnavailableDialogOpen, videoName, templateName, selectedMenu } = this.state
        const selectedSceneGroup = this.getSelectedSceneGroup();
        const selectedSceneCopyAvailable = selectedSceneGroup ? selectedSceneGroup.isCopyAvailable : false
        const selectedSceneDeleteAvailable = selectedSceneGroup ? selectedSceneGroup.isDeleteAvailable : false
        const selectedSceneGroupStatus = selectedSceneGroup ? selectedSceneGroup.status : null
        const isVChangeOnlyTemplate = this.state.template && this.state.template.Name.includes("6041a5ed59babc0a5156abe8")
        var makingProps = {
            templateName,
            videoName,
            index: this.state.selectedIndex,
            maxSceneCount: this.state.template ? this.state.template.Scenes.length : 0,
            scene: template ? template.Scenes[selectedIndex] : null,
            preview: template && template.Scenes && template.Scenes[selectedIndex] ? template.Scenes[selectedIndex].Preview : null,
            selectBeforeScene: this.selectBeforeScene,
            selectAfterScene: this.selectAfterScene,
            handleChangedSliderValue: this.handleChangedSliderValue,
            layerSelectEvent: this.selectLayer,
            selectedLayer: this.state.selectedLayer,
            material: this.state.material,
            progress: this.getProgress(),
            addTextToMaterial: this.addTextToMaterial,
            addFootageToMaterial: this.addFootageToMaterial,
            getFile: this.getPaletteItem,
            cropImage: this.cropImage,
            templateWidth: this.state.template ? this.state.template.Width : 0,
            templateHeight: this.state.template ? this.state.template.Height : 0,
            sendPreviewRequest: this.sendPreviewRequest,
            isWaitForPreview: this.state.isWaitForPreview,
            previewImageURL: this.previewImageURL,
            handleClickPreviewImage: this.handleClickPreviewImage,
            lang: this.state.lang,
            handleFocusTextArea: this.handleFocusTextArea,
            isNoPayment: this.state.isNoPayment,
            lastPreviewRequestedDate: this.state.lastPreviewRequestedDate,
            handleClickFontIcon: this.handleClickFontIcon,
            selectedMenu: this.state.selectedMenu,
            enableAdjustLength: isEditableApproved && (isVChangeOnlyTemplate || availableFunc.AdjustLength),
            availableFunc: this.state.availableFunc,
            handleClickLengthAdjustMinusBtn: this.handleClickLengthAdjustMinusBtn,
            handleClickLengthAdjustPlusBtn: this.handleClickLengthAdjustPlusBtn,
            handleClickLengthAdjustResetBtn: this.handleClickLengthAdjustResetBtn,
            onAlertDialogOpen: this.handlePaymentAlertDialogOpen,
            sendSaveTemporarilyRequest: this.sendSaveTemporarilyRequest,
            showUploadPercentage: this.state.showUploadPercentage,
            isDetectedEmptyFootage: this.isDetectedEmptyFootage,
            sendRenderRequest: this.sendRenderRequest,
            saveState: this.state.saveState,
            uploadPercenage: this.state.uploadPercenage,
            changeMenu:this.changeMenu,
            clickImage: this.clickImage
        }
        var cropProps = {
            open: this.state.isCropped,
            closeDialog: this.cropPopupClose,
            fileName: this.state.cropFileName,
            src: this.state.cropSrc,
            srcInfo: this.state.cropSrcInfo,
            aspect: this.state.cropAspect,
            cropComplete: this.state.cropComplete,
            mimetype: this.state.cropFileType,
            cropFile: this.state.cropFile,
            cropType: this.state.cropType,
            cropDuration: this.state.cropDuration,
            cropDes: this.state.cropDes,
            cropDesDuration: this.state.cropDesDuration,
            cropBlobData:this.state.cropBlobData,
            cropUploadType:this.state.cropUploadType,
            cropMetaData: this.state.cropMetaData
        }
        var timelineProps = {
            index: this.state.selectedIndex,
            selectedSceneGroupIndex: this.state.selectedSceneGroupIndex,
            scenes: this.state.template ? this.state.template.Scenes : null,
            sceneGroups: this.state.sceneGroups,
            previews: this.state.previews,
            selectScene: this.selectScene,
            lang: this.state.lang,

            sceneGroupPopUpMenuProps: {
                isAvaliable: isEditableApproved && (isVChangeOnlyTemplate || availableFunc.AdjustLength),
                targetElementId: selectedSceneGroupElementId,
                isSelectedOriginaScene: this.isSelectedOriginaScene,
                onClickDuplicateMenu: selectedSceneGroupStatus === 'Activated' && selectedSceneCopyAvailable ? this.handleClickSceneGroupDuplicateMenu : null,
                onClickDeleteMenu: selectedSceneGroupStatus === 'Activated' && selectedSceneDeleteAvailable ? this.handleClickSceneGroupDeleteMenu : null,
                onClickRestoreMenu: selectedSceneGroupStatus === 'Deleted' ? this.handleClickSceneGroupRestoreMenu : null
            }
        }
       
        return (
            <div className="layout make-video-root">
                <Prompt when={this.lastUpdated !== null} message={i18n.t("makevideo.leave.alert")}></Prompt>
                {
                    !this.state.template || isLoading
                        ? <Loading />
                        : <>
                            <div className="left-sidebar">
                                <PaletteMenu value={this.props.value}>
                                    <PaletteItem // 워크스페이스
                                        isAvaliable={true}
                                        value={this.props.value}
                                        selected={this.state.selectedMenu === "workspace"}
                                        src="https://front.videomonster.com/images-7cuytg20/common/v2/tab-media.svg"
                                        selectedSrc="https://front.videomonster.com/images-7cuytg20/common/v2/tab-media-active.svg"
                                        itemName={i18n.t("makevideo.paletteitem.media")}
                                        onClick={() => { this.changeMenu("workspace") }}
                                        tooltipContent={<PaletteItemTooltipContent kind={'workspace'} />}
                                    />
                                    <PaletteFont // 폰트
                                        isTextLayer={this.state.isTextLayer}
                                        isAvaliable={this.getFontPaletteAvaliableCheck()}
                                        selected={this.state.selectedMenu === 'font'}
                                        src="https://front.videomonster.com/images-7cuytg20/common/v2/tab-font.svg"
                                        selectedSrc="https://front.videomonster.com/images-7cuytg20/common/v2/tab-font-active.svg"
                                        itemName={i18n.t("makevideo.paletteitem.font")}
                                        onClick={() => { this.changeMenu('font') }}
                                        tooltipContent={<PaletteItemTooltipContent kind={!this.state.isTextLayer ? 'disableFont' : 'font'} />}
                                    />
                                    <PaletteItem // 음악
                                        value={this.props.value}
                                        isAvaliable={isVchangeUser || availableFunc.MusicChange}
                                        selected={this.state.selectedMenu === "music"}
                                        src="https://front.videomonster.com/images-7cuytg20/common/v2/tab-music.svg"
                                        selectedSrc="https://front.videomonster.com/images-7cuytg20/common/v2/tab-music-active.svg"
                                        itemName={i18n.t("makevideo.paletteitem.music")}
                                        onClick={() => { this.changeMenu("music") }}
                                        tooltipContent={<PaletteItemTooltipContent kind={'music'} />}
                                    />
                                    <PaletteItem // 비율 교체
                                        value={this.props.value}
                                        isAvaliable={availableFunc.DesignChange}
                                        selected={this.state.selectedMenu === "ratio"}
                                        src="https://front.videomonster.com/images-7cuytg20/common/v2/tab-change-ratio.svg"
                                        selectedSrc="https://front.videomonster.com/images-7cuytg20/common/v2/tab-change-ratio-active.svg"
                                        itemName={i18n.t("makevideo.paletteitem.ratio")}
                                        onClick={() => { this.changeMenu("ratio") }}
                                        tooltipContent={<PaletteItemTooltipContent kind={'ratio'} />}
                                    />
                                    <div className={'editor-exit-btn'} onClick={() => { this.handleExit() }}>
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/v2/exit.svg" alt="" draggable={false}></img>
                                        <p lang={this.props.value}>{i18n.t("global.exit")}</p>
                                    </div>
                                </PaletteMenu>
                                <WorkspacePalette
                                    onAddItem={this.addPaletteItem}
                                    getFile={this.getPaletteItem}
                                    onRemoveItem={this.removePaletteItem}
                                    palette={this.palette}
                                    enabled={this.state.selectedMenu === 'workspace'}
                                    history={this.props.history}
                                />
                                <FontPalette
                                    enabled={this.state.selectedMenu === 'font'}
                                    {...this.props}
                                    globalFontList={this.state.globalFontList}
                                    myFontList={this.state.myFontList}
                                    comp={this.state.selectedComposition}
                                    currentTextLayerAttr={this.state.currentTextLayerAttr}
                                    currentTextOption={this.state.currentTextOption}
                                    applyTextFontOption={this.applyTextFontOption}
                                    replaceAllTextFontOption={this.replaceAllTextFontOption}
                                    uploadMyFont={this.uploadMyFont}
                                    deleteMyFont={this.deleteMyFont}
                                    isFontFileUploading={this.state.isFontFileUploading}
                                    fontFileUploadProgress={this.state.fontFileUploadProgress}
                                    disableUploadFont={isVchangeUser}
                                />
                                <MusicPalette
                                    videoId={this.getId()}
                                    enabled={this.state.selectedMenu === 'music'}
                                    handleClickMusic={this.handleClickMusic}
                                    handleClickReturnToDefaultMusicBtn={this.handleClickReturnToDefaultMusicBtn}
                                    curMaterialMusic={this.state.material.Music}
                                    videoLength={videoLength}
                                    initMaterialMusic={this.initMaterialMusic}
                                    disableUploadFont={isVchangeUser}
                                    defaultMusicInfo={templateOrigin && templateOrigin.musicInfo}
                                    changeMusicInfo={this.state.changeMusicInfo}
                                    materialMusicInfo={this.state.material.Music}
                                />
                                <RatioPalette
                                    enabled={this.state.selectedMenu === 'ratio'}
                                    handleClickOtherRatio={this.handleClickOtherRatio}
                                    selectedRatio={this.state.selectedRatio}
                                    ratioArr={this.state.ratioArr}
                                />
                            </div>
                            <div className="editor-area scroll">
                                {/* {!this.state.reEditMode && <TitleInput open={this.state.visibleTitlePopUp} onChange={this.changeTitle} onTitleSubmitButtonClicked={this.onTitleSubmitButtonClicked} visibleTitleNull={this.state.visibleTitleNull}></TitleInput>} */}
                                {this.state.cropType === 'image' && <ImageCropDialog {...cropProps}></ImageCropDialog>}
                                {(this.state.cropType === 'video' || this.state.cropType === 'gettyimages_video') && <VideoCropDialog {...cropProps}></VideoCropDialog>}
                                {this.state.cropType === 'gettyimages' && <GettyCropDialog {...cropProps} />}
                                {/* {this.state.cropType === 'gettyimages_video' && <NewGettyCropDialog {...cropProps} />} */}
                                {this.state.cropType === 'music' && cropProps.open && <EditVideoMusicDialog {...cropProps} cashedMediaInfoMap={this.cashedMediaInfoMap} handleChangeCashedMediaInfoMap={this.handleChangeCashedMediaInfoMap} onEditVideoMusicComplete={this.handleEditVideoMusic} waveformRef={this.waveformRef} isReadyWavesurfer={isReadyWavesurfer} />}

                                <Uploading open={this.state.isUploaded}>{`${i18n.t("makevideo.uploading")} (${Math.floor(this.state.uploadPercenage * 100) / 100}%)`}</Uploading>
                                <Uploading open={this.state.isFontFileUploading}>{i18n.t("makevideo.uploading")}</Uploading>
                                <Uploading open={this.state.isImageLoading}></Uploading>

                                <>
                                    <MakingPanel
                                        value={this.props.value}
                                        currentUser={this.props.currentUser}
                                        {...makingProps}
                                    />
                                    <Timeline {...timelineProps} />
                                </>
                                <UploadCompleted
                                    showGallery={this.state.isShowGallery}
                                    // isHideGalleryState={this.state.isHideGalleryState}
                                    isCheckGalleryUpload={this.state.isCheckGalleryUpload}
                                    clickShowGallery={this.clickShowGallery}
                                    hide={true}
                                    fullWidth={this.state.fullWidth}
                                    dialogHeadText={i18n.t("makevideo.paletteitem.UploadCompleted.dialogHeadText1")}
                                    dialogBodyText1={
                                        <span>
                                            <Trans i18nKey="makevideo.paletteitem.UploadCompleted.dialogBodyText4">
                                                <span style={{ color: "#1fbdcb" }} />
                                            </Trans>
                                        </span>
                                    }
                                    DesignedButtonText={i18n.t("makevideo.paletteitem.UploadCompleted.DesignedButtonText1")}
                                    open={this.state.isUploadCompleted}
                                    closeUploadCompletedDialog={this.closeUploadCompletedDialog}
                                    closeBtn={this.handleClose}
                                    left={this.props.value === "ko" ? 20 : 75}
                                    width={this.props.value === "ko" ? "277px" : "300px"}
                                />
                                <AdjustLengthAlertDialog
                                    fullWidth={this.state.fullWidth}
                                    dialogHeadText={i18n.t("makevideo.paletteitem.AdjustLengthAlertDialog.dialogHeadText1")}
                                    dialogBodyText1={i18n.t("makevideo.paletteitem.AdjustLengthAlertDialog.dialogBodyText1")}
                                    dialogBodyText2={i18n.t("makevideo.paletteitem.AdjustLengthAlertDialog.dialogBodyText2")}
                                    DesignedButtonText={i18n.t("global.confirm")}
                                    open={this.state.isShowAdjustLengthAlert}
                                    closeUploadCompletedDialog={this.handleCloseAdjustLengthAlert}
                                    closeBtn={this.handleCloseAdjustLengthAlert}
                                    left={this.props.value === "ko" ? 20 : 75}
                                    width={this.props.value === "ko" ? "277px" : "300px"}
                                />

                                {/* <UploadCompleted
                                dialogHeadText={i18n.t("makevideo.paletteitem.UploadCompleted.dialogHeadText2")}
                                dialogBodyText1={i18n.t("makevideo.paletteitem.UploadCompleted.dialogBodyText2")}
                                noButton={true}
                                open={this.state.isSaveTemporarilyUploadCompleted}
                                closeUploadCompletedDialog={this.closeSaveTemporarilyUploadCompletedDialog}
                                closeBtn={this.handleSaveTemporarilyClose}>
                            </UploadCompleted>
                            <UploadCompleted
                                dialogHeadText={i18n.t("global.alert")}
                                dialogBodyText1={i18n.t("makevideo.paletteitem.UploadCompleted.dialogBodyText3")}
                                noButton={true}
                                open={this.state.pathAlert}
                                closeUploadCompletedDialog={this.pathAlert}
                                closeBtn={this.handlepathAlert}>
                            </UploadCompleted> */}

                                <Maintain
                                    isServerCheck={this.state.isServerCheck}
                                    description={this.state.description}
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    maintainCloseBtn={this.maintainCloseBtn}
                                    editWindow
                                />

                                {/* value가 언어 선택입니다. */}
                                {/* <TutorialEn
                                value={this.props.value}
                                open={this.props.value === 'en' && this.state.tutorialOpen}
                                closeBtn={this.onTutorialClose}
                            />
                            <Tutorial
                                value={this.props.value}
                                // open = {true}
                                open={this.props.value !== 'en' && this.state.tutorialOpen}
                                closeBtn={this.onTutorialClose}
                            /> */}


                                <PreviewImage
                                    open={this.state.isPreviewImageOpen}
                                    src={this.state.previewSrc}
                                    close={this.handleClosePreviewImage}
                                />
                                <TwoBtnDialog
                                    open={this.state.isPaymentAlertDialogOpen}
                                    header={i18n.t("payment.alert.header")}
                                    onClose={() => this.setState({ isPaymentAlertDialogOpen: false })}
                                    onClick={() => {
                                        this.setState({ isPaymentAlertDialogOpen: false })
                                        window.open("/payment", "_blank")
                                    }}
                                    confirmBtnLabel={i18n.t("web.newhome.premium.section.paymentbtn")}
                                    cancelBtnLabel={i18n.t("global.cancel")}
                                >
                                    <div>{i18n.t("payment.alert.body")}</div>
                                </TwoBtnDialog>
                                <TwoBtnDialog
                                    open={this.state.isOpenMusicLengthNoticeDialog}
                                    header={i18n.t("makevideo.editvideomusic.length.notice.title")}
                                    closeBtn={this.handleCloseMusicLengthNoticeDialog}
                                    onClose={this.handleCloseMusicLengthNoticeDialog}
                                    onClick={this.handleContinueMusicLengthNoticeDialog}
                                    confirmBtnLabel={i18n.t("makevideo.editvideomusic.length.notice.continue")}
                                >
                                    <div>
                                        {i18n.t("makevideo.editvideomusic.length.notice.message")}
                                    </div>
                                    <div style={{ paddingTop: `10px` }}>
                                        <Trans
                                            i18nKey="makevideo.editvideomusic.length.notice.message2"
                                            values={{ length: videoLength.toFixed(1) }}
                                        />
                                    </div>
                                </TwoBtnDialog>

                                <TwoBtnDialog
                                    open={this.state.isOpenReturnToDefaultMusicDialog}
                                    header={i18n.t("makevideo.editvideomusic.return.music.title")}
                                    closeBtn={this.handleCloseReturnToDefaultMusicDialog}
                                    onClose={this.handleCloseReturnToDefaultMusicDialog}
                                    onClick={this.handleConfirmReturnToDefaultMusicDialog}
                                >
                                    <div>{i18n.t("makevideo.editvideomusic.return.music.message")}</div>
                                    <div style={{ paddingTop: "5px" }}>{i18n.t("makevideo.editvideomusic.return.music.message2")}</div>
                                </TwoBtnDialog>

                                <TwoBtnDialog
                                    open={this.state.isOpenMusicLengthSettingDialog}
                                    header={this.state.changeMusicInfo ? i18n.t("makevideo.editvideomusic.length.notice.timeout") : i18n.t("makevideo.editvideomusic.length.notice.reset")}
                                    onClose={this.handleCompleteMusicLengthSettingDialog}
                                    onClick={this.handleResetMusicLengthSettingDialog}
                                    cancelBtnLabel={i18n.t("makevideo.editvideomusic.length.notice.complete")}
                                    confirmBtnLabel={i18n.t("makevideo.editvideomusic.length.notice.resetbtn")}
                                >
                                    {
                                        this.state.changeMusicInfo
                                            ?
                                            <Trans i18nKey="makevideo.editvideomusic.length.notice.timeout.message"><br /></Trans>
                                            :
                                            <Trans i18nKey="makevideo.editvideomusic.length.notice.reset.message"><br /></Trans>
                                    }
                                </TwoBtnDialog>

                                <TwoBtnDialog
                                    open={this.state.isOpenMusicSectionSettingDialog}
                                    header={i18n.t("makevideo.editvideomusic.length.notice.exceed")}
                                    onClose={this.handleCompleteMusicSectionSettingDialog}
                                    onClick={this.handleResetMusicSectionSettingDialog}
                                    cancelBtnLabel={i18n.t("makevideo.editvideomusic.length.notice.complete")}
                                    confirmBtnLabel={i18n.t("makevideo.editvideomusic.length.notice.resetbtn")}
                                >
                                    <Trans i18nKey="makevideo.editvideomusic.length.notice.exceed.message"><br /></Trans>
                                </TwoBtnDialog>
                                <TwoBtnDialog
                                    open={this.state.isOpenUseCreditDialog}
                                    header={i18n.t("common.getty.use.credit")}
                                    // onClose={()  => {undefined}}
                                    // onClick={() => {undefined}}
                                    cancelBtnLabel={i18n.t("global.cancel")}
                                    confirmBtnLabel={i18n.t("global.confirm")}
                                >
                                    <div>{i18n.t("common.use.getty.credit.alert")}</div>
                                </TwoBtnDialog>
                                <AiTextDialog
                                    open={this.state.isOpenAiTextDialog}
                                    // onClose={()  => {undefined}}
                                    // onCancel={()  => {undefined}}
                                    onChange={this.changeTitle}
                                // onOk={()  => {undefined}}
                                />
                                <UnavailableDialog
                                    open={isUnavailableDialogOpen}
                                    onClose={() => this.setState({ isUnavailableDialogOpen: false })}
                                />
                            </div>
                    </>
                }
            </div>

        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    value: state.langStore.lang,
    paymentMode: state.paymentModeStore.paymentMode,
})

export default connect(
    mapStateToProps,
    null
)(MakeVideo)